export const Spanish = {
  lang: 'es',
  wizard: {
    createAccount: 'Crea tu cuenta gratuita',
    noCreditCard: 'Sin tarjeta de crédito, cancela en cualquier momento',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo Electrónico',
    role: 'Cargo',
    dialCode: 'País',
    fullNumber: 'País y teléfono',
    password: 'Contraseña',
    saveButton: 'Enviar',
    captchaError: 'Captcha no ha sido validado',
    inputError: 'Completar campo',
    emailExistsError: 'El correo electrónico se encuentra en uso',
    emailError: 'Correo electrónico inválido',
    emailInfo: 'Con este correo puedes entrar a la aplicación móvil y web',
    passwordError: 'Debe contener al menos 6 caracteres',
    privacyMessage: 'Haciendo click aceptas que estás de acuerdo con la ',
    privacy: 'Política de Privacidad',
    preparingForm: 'Estamos creando tu cuenta y preparando el formulario',
    preparingForm2: 'Esto puede tardar unos segundos',
    preparingForm3: 'Estamos preparando el formulario',
    userHasAccount: '¿Ya tienes cuenta?',
    login: 'Inicia sesión',
    onboardingVideo:
      'Mira este breve video y descubre cómo Datascope puede transformar tus procesos y hacer tu trabajo más fácil',
    onboardingVideoTitle: '¿Qué puede hacer Datascope por ti?',
    onboardingVideoSkip: 'Continuar',
    onboardingResetModal: {
      title: 'Aún no terminas de configurar tu cuenta',
      message:
        'No terminaste de configurar tu cuenta. ¿Quieres continuar donde la dejaste o empezar desde cero?',
      cancelButtonText: 'Comenzar de nuevo',
      confirmButtonText: 'Continuar',
      error: 'Error restableciendo la información de la cuenta',
    },
    onboardingLogoutModal: {
      title: '¿Estás seguro que quieres salir del proceso de configuración?',
      message: 'Si cierras sesión, podrás retomarlo más tarde al volver a iniciar sesión.',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Cerrar sesión',
    },
    back: 'Volver',
    intro: '¡Hola! Empecemos con lo básico',
    introDescription:
      'Ayúdanos a conocerte mejor para que podamos personalizar tu experiencia y ofrecerte justo lo que necesitas.',
    companyName: 'Nombre de tu empresa',
    industry: 'Tu industria',
    phoneNumber: 'Tu teléfono',
    next: 'Siguiente',
    phoneNumberError: 'El número de teléfono debe tener al menos 8 dígitos',
    firstNameError: 'El nombre es obligatorio',
    lastNameError: 'El apellido es obligatorio',
    companyNameError: 'El nombre de la empresa es obligatorio',
    industryError: 'La industria es obligatoria',
    noResults: 'No hay resultados',
    searchCountry: 'Buscar país...',
    selectOption: 'Selecciona una opción',
    namePlaceholder: 'Escribe tu nombre',
    companyPlaceholder: 'Escribe el nombre de tu empresa',
    search: 'Buscar',
    formErrors: 'Por favor completa todos los campos requeridos',
    industries: {
      agriculture: 'Agro',
      food: 'Alimentos',
      automotive: 'Automotriz',
      construction: 'Construcción',
      consulting: 'Consultoría',
      energy: 'Energía',
      facility: 'Facility Services',
      forestry: 'Forestal',
      engineering: 'Ingeniería',
      cleaning: 'Limpieza y Mantenimiento',
      logistics: 'Logística',
      machinery: 'Maquinaria',
      manufacturing: 'Manufactura',
      mining: 'Minería',
      retail: 'Retail',
      public: 'Sector Público',
      environment: 'Servicios Ambientales',
      health: 'Servicios de Salud',
      communication: 'Telecomunicaciones',
      transport: 'Transporte y Carga',
      wine: 'Vinos',
    },
    roles: {
      management: 'Gerencia',
      consulting: 'Asesoría o Consultoría',
      owner: 'Dueño/a',
      leadership: 'Jefatura',
      student: 'Estudiante',
      independent: 'Independiente',
      analyst: 'Analista',
      other: 'Otro',
    },
    roleRequired: 'Por favor selecciona un rol',
    roleQuestion: 'Ahora cuéntanos, ¿Cuál es tu rol en la organización?',
    roleQuestionDescription: 'Esto nos ayudará a brindarte una mejor experiencia',
    areas: {
      security: 'Seguridad e higiene',
      quality: 'Calidad',
      operations: 'Operaciones/Servicios (OT/OS)',
      audit: 'Auditoría',
      general: 'Uso general',
    },
    areaRequired: 'Por favor selecciona un área',
    areaQuestion: '¿En qué área te gustaría enfocarte hoy?',
    areaQuestionDescription: 'Selecciona el área que más te interesa',
    selectOptions: 'Selecciona las opciones que te interesen',
    selectRequired: 'Por favor selecciona al menos una opción',
    interests: {
      security: {
        question: '¿Qué te gustaría gestionar en seguridad e higiene?',
        options: {
          register_talks: 'Registro de charlas',
          fatality_risks: 'Riesgos de fatalidad',
          risks_matrices: 'Matrices de riesgos',
          safety_work_analysis: 'Análisis seguro del trabajo',
          accidents: 'Accidentes e incidentes',
          inspection_checklist: 'Checklist de inspecciones',
          training_records: 'Registros de capacitaciones',
        },
      },
      quality: {
        question: '¿Qué aspecto de calidad te gustaría gestionar?',
        options: {
          standard_procedures: 'Procedimientos Operativos Estándar (POE)',
          preoperational_verifications: 'Verificaciones preoperacionales',
          quality_control: 'Control de calidad',
          audit_plans: 'Planes de auditoría',
          non_conformity_records: 'Registros de no conformidades',
          legal_records: 'Registros legales',
        },
      },
      operations: {
        question: '¿Qué operaciones deseas administrar?',
        options: {
          maintenance_programs: 'Programas de mantenimiento',
          calibrations: 'Calibraciones',
          installations: 'Instalaciones',
          failure_records: 'Registros de fallas',
          daily_reports: 'Reportes diarios',
          certifications: 'Certificaciones',
          warranties: 'Garantías',
          consumption_records: 'Registros de consumo',
          progress_records: 'Registros de avances',
        },
      },
      audit: {
        question: '¿Qué tipo de auditoría te gustaría gestionar?',
        options: {
          quality_audits: 'Auditorías de calidad',
          safety_audits: 'Auditorías de higiene y seguridad',
          equipment_audits: 'Auditorías de equipamentos',
          norms_compliance: 'Cumplimiento de normativas',
          register_audits: 'Registros de auditorías',
          performance_evaluations: 'Evaluaciones de desempeño',
        },
      },
      general: {
        question: '¿Qué funcionalidad general deseas utilizar?',
        options: {
          polls: 'Encuestas',
          inventory: 'Control de inventario',
          attendance: 'Control de asistencia',
        },
      },
    },
    moreThan: 'Más de',
    selectOneOption: 'Por favor selecciona una opción',
    personnelCount: '¿Cuántas personas trabajan en este proceso actualmente?',
    personnelCountDescription: 'Selecciona el número de personas que utilizarán la plataforma',
    complete: 'Finalizar',
  },
  wizardFinish: {
    buildYourFirstForm: 'Crea tu primer formulario',
    yourPick: 'Tu elección',
    formTemplates: 'Plantillas de formularios',
    createForm: 'Crear formulario desde cero',
    importForm: 'Importar Google Form',
    welcome: '¡Bienvenido!',
    welcomeDescription1: 'A partir de ahora, podrás ',
    welcomeDescription2:
      'ingresar a la plataforma web y móvil utilizando las credenciales recien ingresadas.',
    welcomeDescription3:
      'Recuerda que para comenzar a recopilar datos, simplemente debes descargar la aplicación desde Google Play o App Store en tu teléfono o tableta.',
  },
  onboardingTemplates: {
    title: 'Te recomendamos estos formularios según tu uso',
    subtitle: 'Selecciona uno para empezar a trabajar de inmediato',
    answerNow: 'Responder ahora',
    exploreOthers: 'Explorar otros templates',
  },
  task_assigner: {
    only_once: 'Solo una vez',
    working_days: 'Solo días hábiles',
    daily: 'Diariamente',
    weekly: 'Semanalmente',
    monthly: 'Mensualmente',
    yearly: 'Anualmente',
    custom: 'Customizado',
    task_frequency: 'Frecuencia de tareas',
    task_frequency_info:
      'La opción de frecuencia de la tarea está disponible solo cuando se asigna una única fecha',
    assigned: 'Asignadas',
    completed: 'Completas',
    pending: 'Aceptadas',
    incomplete: 'Incompletas',
    states: {
      completed: 'Completa',
      inProgress: 'Aceptada',
      pending: 'Pendiente',
      incomplete: 'Incompleta',
      rejected: 'Rechazada',
      programmed: 'Programada',
      sent: 'Asignada',
    },
    cards: {
      totalTasks: 'Total tareas',
      completed: 'Completas',
      pending: 'Aceptadas',
      incomplete: 'Incompletas',
      rejected: 'Rechazadas',
      programmed: 'Programadas',
      sent: 'Asignadas',
    },
    your_assigned_tasks: 'Tus tareas asignadas',
    filters: 'Filtros',
    new_task: 'Nueva Tarea',
    edit_task: 'Editar Tarea',
    tasks: 'Tareas',
    massive_search: 'Buscar por usuario, formulario o lugar...',
    user: 'Usuario',
    form: 'Formulario',
    place: 'Lugar',
    date: 'Fecha',
    date_and_time: 'Fecha y Hora',
    gap: 'Duración',
    state: 'Estado',
    save: 'Guardar',
    users: 'Usuarios',
    description: 'Descripción',
    hour: 'Hora',
    alert: 'alerta',
    delete: 'Eliminar',
    cancel: 'cancelar',
    accept: 'aceptar',
    notify: 'Notificar',
    notify_user: 'Quieres notificar a ',
    sure: '¿Estás seguro?',
    delete_task: 'Vas a borrar una tarea',
    delete_tasks: 'Quieres borrar estas tareas: ',
    reset: 'Restablecer',
    old_version: 'Version Antigua',
    task_created: 'Tarea Creada',
    our_problem: 'Tenemos un problema',
    task_update: 'Tarea actualizada con éxito',
    export: 'Exportar',
    date_necessary: 'Es necesaria una fecha',
    required: 'Requerido',
    blanck: 'Hay campos vacios',
    notification_sent: 'Notificación enviada con éxito',
    notifications_sent: 'Notificaciones enviadas con éxito',
    tasks_delete:
      'Tareas eliminadas con éxito. Espera unos minutos para ver los cambios reflejados.',
    task_delete: 'Tarea eliminada con éxito',
    new_place: 'Nuevo lugar',
    start: 'Comienzo',
    end: 'Final',
    history: 'Historial',
    actions: 'Acciones',
    dobleClick: 'Doble click en la tarea = abrir detalles',
    shiftMouse: 'shift + rueda del ratón = mover cronograma izquerda/derecha',
    altMouse: 'alt + rueda del ratón = zoom in/out',
    timeline: 'Cronograma',
    taskAssignID: 'ID tarea asignada',
    selected_range: 'Rango seleccionado',
    notifications: 'Agregar notificaciones',
    add_notification: 'Agrega una notificación',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
    notification: 'Notificación',
    email: 'Email',
    max_one_date: 'Máximo una fecha en modo edición',
    max_one_user: 'Máximo un usuario en modo edición',
    no_location_warning: 'No se ha especificado un lugar, o este puede haber sido eliminado.',
    showing_results_for: 'Mostrando resultados para',
    task: 'Tarea',
    no_tasks_available: 'No tienes tareas disponibles en este momento',
    gap_hours: 'Duración de las tareas en horas',
    allow_late_submission:
      'Permitir responder la tarea posterior a que se haya cumplido la fecha establecida',
    add_tasks: 'Agregar tareas',
    add_tasks_caption:
      'Puedes agregar tareas rápidamente separándolas con comas "," o presionando Enter',

    configuration: 'Configuración',
    voluntary_task:
      'Hacer voluntaria esta tarea (Todos los usuarios pueden aceptar/rechazar la tarea)',
    mandatory_task: 'Hacer obligatoria esta tarea (Todos los usuarios deben responder la tarea)',
    notification_type: 'Tipo de notificación',
    notification_time: 'Tiempo',
    notification_period: 'Periodo de tiempo',
    app_notification: 'Notificación en app',
    confirmation_title_prefix: '¿Estás seguro que quieres crear ',
    confirmation_title_suffix: ' tareas?',
    confirmation_title_suffix_one: 'tareas por',
    confirmation_title_suffix_two: 'días?',
    edit_confirmation_title: '¿Estás seguro de que deseas editar esta tarea?',
    success_message:
      '¡Tareas creadas exitosamente! Por favor, espera unos segundos para que se reflejen. Recuerda refrescar la página para visualizarlas.',
    update_success_message: '¡Tarea actualizada exitosamente!',
    forms_info: 'Si seleccionas varios formularios, crearás varias tareas con los seleccionados',
    edit: 'Editar',
    show_answer: 'Ver respuesta',
    notify_title: '¿Estás seguro que quieres notificar al siguiente usuario?',
    bulk_notify_title: '¿Estás seguro que quieres notificar a los siguientes usuarios?',
    delete_title: '¿Estás seguro que quieres eliminar la tarea?',
    delete_description: 'Se eliminará  y no la podrás recuperar',
    bulk_delete_title_one: '¿Estás seguro que quieres eliminar',
    bulk_delete_title_two: 'tareas?',
    bulk_delete_description:
      'Si las eliminas, desaparecerá de la lista de tareas pendientes de los usuarios y no las podrán responder',
    bulk_actions: 'Acciones masivas',
    creation_date: 'Fecha creación',
    start_date: 'Fecha inicio',
    answers: 'Respuestas',
    duration: 'Duración:',
    answered: 'respondieron',
    out_of_time: 'Fuera de tiempo',
    late: 'tarde',
    no_location: 'Sin lugar',
    task_does_not_exist: 'La tarea no existe',
    location_copied: 'Lugar copiado al portapapeles',
    completed_tasks_cannot_be_deleted: 'Las tareas completadas no pueden ser eliminadas',
    complete_task: 'Completar tarea',
    complete_task_description: '¿Quieres completar esta tarea ahora?',
    complete_task_button: 'Completar',
    reject_task_button: 'Rechazar',
    accept_task_button: 'Aceptar',
    accept_reject_confirmation:
      'Puedes aceptarla y completarla, o rechazarla si no puedes realizarla.',
    import: {
      title: 'Importar Tareas',
      step1Title: 'Paso 1: Descargar plantilla',
      step1Description:
        'Descarga el archivo Excel de ejemplo. Asegúrate de completar los campos marcados con * para importar tu archivo correctamente.',
      downloadExample: 'Descargar ejemplo',
      step2Title: 'Paso 2: Editar el archivo',
      step2Description:
        'Completa la plantilla con los datos de tus tareas. Asegúrate de que todos los campos requeridos estén completados.',
      step2MoreInfo: 'Más información aquí',
      step3Title: 'Paso 3: Subir tu archivo',
      step3Description:
        'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora. Podría tardar unos minutos en procesarse.',
      dragDropText: 'Arrastra y suelta tu archivo Excel aquí',
      browseText: 'o búscalo en tu computador',
      replaceText: 'Reemplazar',
      fileUploadedText: 'Tu archivo ha sido cargado',
      invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
      importError: 'Error al importar tareas',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      success: 'Tareas importadas con éxito. Espera unos segundos para que se reflejen.',
      errorTitle: 'Detectamos un error.',
      templateDownloadError: 'Error al descargar la plantilla',
      downloadingTemplate: 'Descargando...',
      baseTemplateUrl: 'https://s3-us-west-2.amazonaws.com/data-scope/templates/',
      templateFileLegacy: `task_assign_es3_v1.xlsx`,
      templateFileV4: `task_assign_es4_v1.xlsx`,
      helpUrl:
        'https://help.mydatascope.com/es/articles/2852072-como-importar-tareas-de-forma-masiva',
      errors: {
        invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
        importError:
          'Error al importar tareas. Por favor, verifica que tus datos tengan el formato correcto.',
        templateDownloadError: 'Error al descargar la plantilla',
        errorTitle: 'Detectamos un error.',
      },
    },
  },
  form_answer: {
    answer_again: 'Responder de nuevo',
    submit_button: 'Enviar',
    edit_button: 'Editar',
    edit_form: 'Editar formulario',
    incomplete_edit_alert: 'Debes responder todas las preguntas requeridas',
    incomplete_submit_alert: 'Aún no subes ninguna respuesta',
    error_submit_alert: 'Hubo un error al intentar subir tu respuesta',
    error_edit_alert: 'Hubo un error al intentar editar tu respuesta',
    no_edit_alert: 'No has editado tu respuesta aún',
    no_answer_alert: 'Tu respuesta esta vacía',
    required_question: 'Esta pregunta es obligatoria',
    no_options: 'No hay opciones',
    invalid_question_type_1: 'Pregunta de tipo ',
    invalid_question_type_2:
      'Este tipo de pregunta no puede ser respondida/editada en nuestra plataforma web. Por favor descargue la aplicación móvil de DataScope.',
    some_invalid_question_types:
      'Advertencia: Este formulario incluye tipos de pregunta no válidos para la versión web de DataScope.',
    download_mobile: 'Descarga nuestra aplicación móvil aquí',
    download_mobile_link: 'https://datascope.page.link/3N7P',
    answer_placeholder: 'Tu respuesta',
    simple_text_placeholder: 'Tu respuesta de texto',
    text_rut_placeholder: 'Tu RUT de respuesta',
    text_container_placeholder: 'Tu ID de contenedor',
    invalidRutError: 'RUT inválido',
    invalidContainerError: 'ID de contenedor inválido',
    text_email_placeholder: 'Tu email de respuesta',
    select_your_date: 'Selecciona una fecha',
    select_your_datetime: 'Selecciona fecha y hora',
    select_your_time: 'Selecciona un horario',
    datetime_errors: {
      invalidDate: 'Fecha inválida',
      minDate: 'La fecha no alcanza el mínimo permitido',
      maxDate: 'La fecha supera el máximo permitido',
    },
    add_repeatable_questions: 'Agregar otro grupo de preguntas',
    signature_type: 'Firma',
    photo_type: 'Foto',
    barcode_type: 'Código de barras',
    filter_elements: 'Buscar elemento...',
    upload_image: 'Subir Imagen',
    no_image_loaded: 'No se ha subido ninguna imágen',
    upload_file: 'Subir Archivo',
    unsupported_file_type: 'Este tipo de archivo no está permitido para esta pregunta',
    exceeded_max_number_files:
      'Has excedido la cantidad máxima de archivos permitidos para esta pregunta',
    image_max_size_exceeded: 'Uno o más de sus archivos superan el límite de',
    image_max_amount_exceeded_part_one: 'Puedes subir hasta',
    image_max_amount_exceeded_part_two: 'imágenes por comentario',
    image_upload_error: 'Ocurrió un error subiendo las imágenes, por favor intente nuevamente',
    no_signature_loaded: 'No has cargado ninguna firma',
    clear: 'Limpiar',
    save_canvas: 'Guardar',
    modify_signature: 'Modificar',
    next: 'Siguiente',
    previous: 'Atrás',
    success_message: 'Hemos recibido tu respuesta correctamente',
    download_app_suggestion:
      '¿Buscando una forma más conveniente y más rápida de responder tus formularios?',
    confirm_section_change:
      'Esta sección tiene una pregunta obligatoria que aún no ha respondido correctamente. ¿Desea continuar de todos modos?',
    load_more_data: 'Cargar más datos',
    no_data_left: 'No quedan datos para cargar',
    clear_all: 'Borrar todo',
    no_header_warning:
      'El creador de esta pregunta no especificó los encabezados de lista de las listas relacionadas.',
    more_answers_alert: 'Baja para ver más',
    subform_limit: 'Límite de grupos de preguntas alcanzado',
    subform_min: 'Por favor agrega el número mínimo de respuestas',
    multi_option_placeholder: 'Selecciona una opción',
    image: 'Imagen',
    download: 'Descargar',
    multiple_options: 'Selecciona múltiples opciones',
    group: 'Grupo',
    start: 'Comienzo',
    end: 'Fin',
    invalid_date: 'Fecha inválida',
    invalid_time: 'Hora inválida',
    optionComments: {
      addNote: 'Añadir una nota',
      removeNote: 'Eliminar nota',
      writeComment: 'Escribe un comentario...',
      requiredNote: 'Comentario requerido',
      addNoteMobile: 'Nota',
      addImage: 'Adjuntar Imagen',
      addImageMobile: 'Imagen',
      removeNoteMobile: 'Eliminar',
      requiredImage: 'Imagen requerida',
      requiredFinding: '{{finding_label_cap}} requerido',
      deleteImageWarningTitle: '¿Estás seguro que quieres eliminar esta imagen?',
      deleteImageWarningSubTitle: 'Una vez que la elimines, no la podrás recuperar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
    },
    drag_drop_file: 'Arrastra y suelta aquí tus archivos',
    or_browse_for_file: 'o búscalos en tu computador',
    missingRequiredAnswersAlert:
      '¡Ups! Parece que aún faltan algunas preguntas por responder. Por favor, completa todas las preguntas requeridas para poder continuar.',
    totalPercentage: 'Porcentaje total',
    enterSampleTotal: 'Ingresa el total de la muestra',
    forbidden_access:
      'Parece que no tienes permiso para editar este formulario. Solicítalo para poder realizar modificaciones',
    automated_signature_on_response:
      'Este formulario tiene firma configurada. La solicitud se enviará a los usuarios asignados al finalizar el formulario.',
    electronic_signature: 'Firma electrónica',
    sign_now: 'Firmar ahora',
    sign_later: 'Firmar más tarde',
    sign_modal_description: 'Este formulario requiere tu firma, ¿quieres firmar ahora?',
    leave_form_title: 'Estás saliendo del formulario',
    leave_form_message:
      'Tienes cambios sin guardar en esta respuesta. Si sales de esta vista ahora, se perderán. ¿Deseas salir y descartar los cambios?',
    leave_stay_button: 'Seguir editando',
    leave_confirm_button: 'Salir y descartar',
    signature_creation_failed: 'Hubo un error al firmar el formulario',
    saveSuccessAndRedirect: '¡Respuesta guardada correctamente! Redirigiendo a tus firmas...',
    saveAndSignSuccessAndRedirect:
      '¡Respuesta guardada y firmada correctamente! Redirigiendo a tus firmas...',
    subtasks: 'Tareas',
    editingActivity: 'Editando actividad',
    selectActivityAndDuration: 'Selecciona actividad y duración',
    update: 'Actualizar',
    add: 'Agregar',
    to: 'a',
    activityPlaceholder: 'Actividad',
    durationPlaceholder: 'Duración',
    durationExceedsLimit: 'La duración supera el tiempo restante',
    cancel: 'Cancelar',
    requiredQuestionIncomplete: 'Todas las horas de trabajo deben ser asignadas',
    deleteActivityMessage: '¿Estás seguro de querer eliminar esta actividad?',
    allActivitiesRegistered: 'Todas las horas asignadas',
    workingTimeNotSet: 'Horas de trabajo no establecidas',
    remainingTimePrefix: 'Te falta asignar',
    activityNotSelected: 'Actividad faltante',
    editActivity: 'Editar',
    insertBelow: 'Insertar abajo',
    deleteActivity: 'Eliminar',
    addActivity: 'Agregar actividad',
    noAssignedLocations:
      'No tienes lugares asignados para este formulario. Contacta a tu administrador.',
  },
  percentage: 'Porcentaje',
  build_your_own_form: 'Construye tu propio formulario con DataScope',
  back_to_taskForms: 'Volver a lista de formularios',
  date_fns: 'es',
  yes: 'Sí',
  no: 'No',
  insert_value: 'Inserte un valor',
  and: 'Y',
  invalidEmail: 'Email inválido',
  ok: 'OK',
  group: 'Grupo',
  folder: 'Folder',
  clearAll: 'Borrar todos',
  users: 'Usuarios',
  forms: 'Formularios',
  actions: 'Acciones',
  select: 'Seleccionar',
  selectAll: 'Seleccionar todos',
  form_builder: {
    formName: 'Nombre del formulario',
    saveForm: 'Guardar',
    title: 'Título',
    titleDescription: 'Título corto para identificar la pregunta. Aparece al exportar los datos.',
    instruction: 'Descripción',
    instructionDescription:
      'Texto más extenso para mostrar en la app. No aparece al exportar datos (Opcional)',
    questionType: 'Cambiar tipo de pregunta',
    copy: 'Duplicar pregunta',
    delete: 'Eliminar pregunta',
    add: 'Agregar nueva pregunta',
    advanced: 'Opciones avanzadas',
    type: 'Tipo',
    date: 'Fecha',
    dateAndTime: 'Fecha y Hora',
    time: 'Hora',
    alternativeColumns: 'Columnas alternativas',
    addOption: 'Agregar opción',
    dataListSource: 'Fuente lista datos',
    changeDataList: 'Cambiar lista de datos',
    listValues: 'Valores lista',
    addListValue: 'Agregar valor lista',
    deleteAlternative: 'Eliminar alternativa',
    required: 'Obligatorio',
    validateRutChile: 'RUT (Chile)',
    validateMail: 'Correo electrónico',
    validateContainer: 'ID de contenedor',
    validate: 'Validar',
    codeType: 'Cambiar tipo de código',
    disableGallery: 'Deshabilitar galería',
    maxImagesPerItem: 'Max. imágenes por ítem',
    moveUp: 'Mover hacia arriba',
    moveDown: 'Mover hacia abajo',
    alternative: 'Alternativa',
    snackBarShared: 'invitaciones enviadas',
    snackBar: 'Tu formulario se ha guardado correctamente!',
    activityStartTimeRequired: 'Define la hora de inicio de la jornada para continuar.',
    newListData: 'Nueva Lista De Datos',
    section: 'Agregar Sección',
    sectionName: 'Sección sin nombre',
    duplicateSection: 'Duplicar sección',
    deleteSection: 'Eliminar sección',
    delSectionsQuestions: 'Eliminar seccion y preguntas',
    areYouSure: '¿Estás seguro/a?',
    cancel: 'Cancelar',
    sectionAlertOne:
      'Se eliminará la sección, pero las preguntas se sumarán a la sección anterior.',
    sectionAlertTwo: 'Se eliminará la sección y también las preguntas que contiene.',
    yesDelete: 'Sí, eliminar',
    questionAlert: 'Esta pregunta se eliminará de forma permanente',
    copyName: 'Copia',
    nameAlert: 'Las preguntas deben tener nombres distintos.',
    isRepeated: 'está repetido.',
    if: 'si',
    is: 'es',
    to: 'a',
    goTo: 'ir a',
    sectionNameTag: 'Nombre sección',
    skipQuestions: 'Saltar preguntas',
    equal: 'igual',
    dif: 'diferente',
    contains: 'contiene',
    notContains: 'no contiene',
    empty: 'vacía',
    notEmpty: 'no vacía',
    skipOnlyMobile: 'Solo aplica para formularios móviles',
    disableSkip: 'Este tipo de pregunta no está habilitada para saltos',
    next: 'siguiente pregunta',
    end: 'terminar formulario',
    payingAlert:
      'Esta funcionalidad no está disponible en el plan gratuito, debe activar su plan en la configuración / facturación.',
    showPercent: 'Mostrar porcentaje',
    showSamplingPercent: 'Mostrar porcentaje muestreo',
    showPrice: 'Mostrar precio',
    showAvg: 'Mostrar promedio',
    showFactor: 'Mostrar multiplicación',
    camQuality: 'Calidad de cámara',
    high: 'Alta',
    mid: 'Media',
    low: 'Baja',
    recommended: 'recomendado',
    photoAlert: 'la sincronización podría tardar más',
    sectionNameAlert:
      'No deberían existir secciones con el mismo nombre. Por favor renombra la sección: ',
    formatType: 'Tipos de formato',
    audioDuration: 'Duración de audio',
    secondsLabel: 'segundos',
    cannotCombineWithVoiceAudioRecording: 'No se puede combinar con grabación de audio',
    anyIncludeAllFormatsExceptVoiceAudioRecording:
      'Cualquiera incluye todos los tipos de archivo, excepto grabación de audio',
    voiceAudioRecording: 'Grabación de audio',
    any: 'Cualquiera',
    howToCreate: 'Cómo crear formularios',
    good: 'Bueno',
    regular: 'Regular',
    bad: 'Malo',
    newOption: 'Nueva opción',
    moveSection: 'Mover sección',
    oldShareForm: 'Comparte este form con un enlace público',
    shareForm: 'Enlace Formulario',
    shareEmail: 'Comparte via email',
    shareWhatsapp: 'Comparte via WhatsApp',
    shareWhatsappMessage: 'Envía tu formulario junto con un mensaje a través de WhatsApp',
    shareWhatsappMessageApi: 'Hola, te invito a responder el siguiente formulario DataScope: ',
    formMadePublic: 'Se ha habilitado el link del formulario',
    undoFormPublic: 'El link del formulario se ha deshabilitado',
    shareForm2: 'Comparte este formulario',
    shareFormTip:
      'Cualquier persona, tanto usuarios registrados como no registrados, podrá completar este formulario web si comparte el enlace público con ellos. Sus respuestas quedarán registradas a nombre de un usuario genérico.',
    shareFormOn: 'Hacer este formulario público',
    shareFormOff: 'Remover acceso público',
    shareViaEmailTip: 'Puedes incluir más de un correo con enter, espacio o coma',
    quantity: 'Cantidad máxima de archivos',
    new: 'Nuevo!',
    warning: 'Temporalmente sólo disponible para formularios web',
    testYourForm1: 'Descarga nuestra App oficial en ',
    testYourForm2: 'Posteriormente puedes iniciar sesión con estas mismas credenciales.',
    testYourForm3: '¡Prueba tu formulario en nuestra app!',
    testYourForm4:
      '¡Escanea este código QR con la cámara de tu celular para visualizar tu formulario!',
    testYourForm5:
      '¡Escanea este código QR con la cámara de tu celular para descargar nuestra app y visualizar tu formulario!',
    copyLink: 'Copiar enlace',
    copiedLink: 'Copiado!',
    visitForm: 'Visitar',
    accessYourForm: 'Accede a tu formulario aquí',
    downloadApp: 'Descarga nuestra app',
    ok: 'ok',
    and: 'y',
    greater: 'Mayor que',
    greaterOrEqual: 'Mayor o igual que',
    less: 'Menor que',
    lessOrEqual: 'Menor o igual que',
    between: 'Entre',
    notBetween: 'No está entre',
    betweenQuestionOffset: 'Entre valor pregunta y desplazamiento',
    dateValidation: {
      addValidation: 'Agregar validación',
      validationType: 'Tipo de validación',
      fixedRange: 'Rango fijo',
      fixedRangeDescription: 'En relación a la fecha de la respuesta',
      fixedRangeDescriptionTime: 'En relación a la hora de la respuesta',
      relativeRange: 'Rango relativo',
      relativeRangeDescription: 'En relación a otra pregunta de fecha del formulario',
      relativeRangeDescriptionTime: 'En relación a otra pregunta de hora del formulario',
      rangeCondition: 'Condición temporal',
      selectRangeCondition: 'Selecciona una opción',
      predefinedConditions: 'Predefinidas',
      customConditions: 'Personalizadas',
      offset: 'Desplazamiento',
      hours: 'Horas',
      days: 'Días',
      day: 'Día',
      hour: 'Hora',
      minimumValue: 'Valor mínimo',
      maximumValue: 'Valor máximo',
      and: 'y',
      minimumValueForOffsetIs: 'El desplazamiento mínimo permitido es de',
      maximumValueForOffsetIs: 'El desplazamiento máximo permitido es de',
      onlyToday: 'Solo hoy',
      noFutureDates: 'No permitir fechas futuras',
      noPastDates: 'No permitir fechas pasadas',
      onlyCurrentTime: 'Solo hora actual',
      noFutureTimes: 'No permitir horas futuras',
      noPastTimes: 'No permitir horas pasadas',
      after: 'Después que',
      afterOrEqual: 'Después o igual que',
      before: 'Antes que',
      beforeOrEqual: 'Antes o igual que',
      between: 'Entre',
      notBetween: 'No está entre',
      rangeValidationErrorMessageForDate: 'El valor debe ser de al menos 1 día.',
      rangeValidationErrorMessageForTime: 'El valor debe estar entre 1 y 23 horas.',
      rangeValidationErrorMessageForDateTime: 'El valor debe ser de al menos 24 horas.',
      datetime: {
        afterMessage:
          'La fecha y hora debe ser posterior al momento en que se responde el formulario, con un máximo de {days} {daysUnit} y {hours} {hoursUnit} después.',
        afterOrEqualMessage:
          'La fecha y hora debe ser igual o posterior al momento en que se responde el formulario, con un máximo de {days} {daysUnit} y {hours} {hoursUnit} después.',
        beforeMessage:
          'La fecha y hora debe ser anterior al momento en que se responde el formulario, con un máximo de {days} {daysUnit} y {hours} {hoursUnit} atrás.',
        beforeOrEqualMessage:
          'La fecha y hora debe ser el día en que se responde el formulario o hasta {days} {daysUnit} y {hours} {hoursUnit} atrás.',
        betweenMessage:
          'La fecha y hora debe estar dentro del rango que va desde {daysBefore} {daysBeforeUnit} y {hoursBefore} {hoursBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} y {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
        notBetweenMessage:
          'La fecha y hora debe estar fuera del rango que va desde {daysBefore} {daysBeforeUnit} y {hoursBefore} {hoursBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} y {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
      },
      date: {
        afterMessage:
          'La fecha debe ser posterior al día en que se responde el formulario, con un máximo de {days} {daysUnit} después.',
        afterOrEqualMessage:
          'La fecha debe ser el día en que se responde el formulario o hasta {days} {daysUnit} después.',
        beforeMessage:
          'La fecha debe ser anterior al día en que se responde el formulario, con un máximo de {days} {daysUnit} atrás.',
        beforeOrEqualMessage:
          'La fecha debe ser el día en que se responde el formulario o hasta {days} {daysUnit} atrás.',
        betweenMessage:
          'La fecha debe estar dentro del rango que va desde {daysBefore} {daysBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} después del momento en que se responde el formulario.',
        notBetweenMessage:
          'La fecha debe estar fuera del rango que va desde {daysBefore} {daysBeforeUnit} antes hasta {daysAfter} {daysAfterUnit} después del momento en que se responde el formulario.',
      },
      time: {
        afterMessage:
          'La hora debe ser posterior al momento en que se responde el formulario, con un máximo de {hours} {hoursUnit} después.',
        afterOrEqualMessage:
          'La hora debe ser en el momento en que se responde el formulario o hasta {hours} {hoursUnit} después.',
        beforeMessage:
          'La hora debe ser a lo más {hours} {hoursUnit} antes del momento en que se responde el formulario.',
        beforeOrEqualMessage:
          'La hora debe ser en el momento en que se responde el formulario o hasta {hours} {hoursUnit} atrás.',
        betweenMessage:
          'La hora debe estar dentro del rango que va desde {hoursBefore} {hoursBeforeUnit} antes hasta {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
        notBetweenMessage:
          'La hora debe estar fuera del rango que va desde {hoursBefore} {hoursBeforeUnit} antes hasta {hoursAfter} {hoursAfterUnit} después del momento en que se responde el formulario.',
      },
    },
    number: 'Número',
    noValidation: 'Sin validación',
    validNumberWarning: 'Ingresa un número válido',
    validSetWarning: 'Ingresa un rango válido',
    separator: 'Separador',
    separatorWarning: 'Ingresa un separador válido',
    relatedList: 'Lista relacionada',
    updateMeter: 'Actualizar medidor',
    selectMeter: 'Selecciona el medidor a actualizar',
    selectMeterQuestion: 'Elige la pregunta que captará el dato',
    addMeterQuestion: 'Agregar otra pregunta que capture el dato',
    createNumberQuestion: 'Crear pregunta tipo número',
    header: 'Encabezado',
    headerPlaceholder: 'País | Ciudad | Calle',
    headerWarning: 'Debes ingresar un encabezado que contenga al separador',
    headerDefault: 'Lista sin encabezado',
    deprecatedWarning: 'Este tipo de pregunta ya no es compatible',
    combineAlert1: 'Solo se pueden añadir preguntas al grupo de preguntas repetibles.',
    combineAlert2:
      'Una pregunta dentro de un grupo de preguntas repetibles no puede contener otro grupo de preguntas repetibles.',
    combineAlertTitle: 'Error',
    emptySubform: 'Vaciar',
    emptySubformAlert:
      'El grupo de preguntas repetibles no puede estar vacío, una pregunta ha sido creada automáticamente.',
    emptySubformAlertTitle: 'Cuidado',
    emptySubformTooltip: 'Eliminar todas las preguntas del grupo de preguntas repetibles',
    removeSubformQuestionTooltip: 'Eliminar pregunta del grupo de preguntas repetibles',
    subformRemoveConfirm:
      'Esta pregunta se eliminará de este grupo de preguntas repetibles y se agregará al formulario principal.',
    subformEmptyConfirm:
      'Todas las preguntas se eliminarán del grupo de preguntas repetibles y se agregarán al formulario principal.',
    confirm: 'Confirmar',
    subformLimit: 'Limitar repeticiones',
    subformWarning: 'Para más de 5 repeticiones, actualiza tu plan en configuración > facturación',
    answer: 'Responder',
    includeComments: 'Comentario',
    commentsFormLabel:
      'Selecciona las respuestas en las que deseas incluir un comentario obligatorio',
    textCommentBtnTooltip: 'Texto Requerido',
    imageCommentBtnTooltip: 'Imagen Requerida',
    findingCommentBtnTooltip: '{{finding_label_cap}} Requerido',
    imageCommentBtnTooltipDisabled: 'No puedes agregar más de 500 imágenes en total',
    share: 'Compartir',
    mobileTab: 'Celular',
    webTab: 'Computador',
    max: 'Máximo',
    min: 'Mínimo',
    asCount: 'Conteo',
    dataListSearchModalTitle: 'Mis listas',
    editLists: 'Editar listas',
    editLocations: 'Editar lugares',
    use: 'Usar',
    usedInThisForm: 'Usadas en este formulario',
    otherLists: 'Otras listas',
    customLists: 'Personalizadas',
    locations: 'Lugares',
    selectAll: 'Seleccionar todos',
    customLocations: 'Lugares personalizados',
    searchInListPlaceholder: 'Buscar en esta lista...',
    locationAccessAlert:
      'Algunos usuarios podrían no ver esta pregunta si no tienen acceso a los lugares seleccionados',
    customListsDescription:
      'Almacena cualquier tipo de datos que requieras consultar (incluye lugares antiguos)',
    locationsDescription: 'Centraliza y controla la información de tus espacios físicos',
    assetsDescription: 'Gestiona activos con toda su información, ubicación y medidores',
    selectDataListInstruction: 'Selecciona la lista de datos que mejor se ajuste a tu pregunta',
    multi_photo: 'Múltiples fotos',
    mobileOnlyAlert:
      'Disponible solo en la app. Si haces esta pregunta obligatoria, podrás responder el formulario desde web, pero la pregunta no aparecerá.',
    oldLocationsListWarning:
      'Estás usando una lista de lugares antigua. Crea una nueva para aprovechar los beneficios.',
    availableAppWeb: 'Disponible en web y app',
    imageDisabledByLimit:
      'La opción de imagen fue deshablitada. No es posible subir más de 500 imágenes en total',
    formBuilderBlockedAlertPart1:
      'No tienes permisos para editar este formulario. Si quieres crear o editar formularios ',
    formBuilderBlockedAlertPart2: 'actualiza tu plan',
    formBuilderBlockedAlertPart3: ' ahora y desbloquea la productividad sin límites',
    formNameExists: 'El nombre del formulario ya existe',
    saveError: 'Error al guardar el formulario',
    formLockedForEditing: 'El formulario está bloqueado para la edición.',
    validationFixedRange: 'Rango fijo',
    validationRelativeRange: 'Rango relativo(solo disponible en app)',
    validationComparisonType: 'Tipo de comparación',
    validationSelectComparisonType: 'Selecciona tipo de comparación',
    minimumValue: 'Valor mínimo',
    maximumValue: 'Valor máximo',
    offset: 'Desplazamiento',
    pickQuestion: 'Selecciona una pregunta',
    noQuestionsAvailable: 'No hay preguntas disponibles para comparación',
    validationType: 'Tipo de validación',
    theNumberMustBe: 'El número debe ser',
    theNumberMustNotBe: 'El número no debe ser',
    than: 'que',
    plus: 'más',
    minus: 'menos',
    hoursLabel: 'hrs',
    hourLabel: 'hr',
    andMinutesLabel: 'y',
    minuteLabel: 'minuto',
    minutesLabel: 'minutos',
    activityStartTime: 'Selecciona la hora de inicio de jornada',
    activityDuration: 'Selecciona la duración de la jornada',
    activityInterval: 'Selecciona el intervalo de tiempo',
    every: 'Cada',
    tabs: {
      builder: 'Editor de formularios',
      integrations: 'Integraciones',
      signature: 'Firma',
      email: 'Email',
      pdf: 'PDF',
    },
    dynamicSignatureModificationAlert: {
      title: 'Algunas firmas podrían dejar de funcionar',
      description:
        'Los cambios que estás realizando podrían afectar las firmas electrónicas asociadas a estas preguntas.\nSi continúas, esas firmas podrían desactivarse.',
      continue: 'Continuar',
      cancel: 'Cancelar',
    },
  },
  help: {
    multi_option: 'Selecciona una alternativa en una lista de elementos',
    select_metadata: 'Selecciona una alternativa dentro de una lista de datos dinámica',
    select_option_metadata: 'Selecciona una alternativa para cada elemento de la lista',
    select_option_metadata_comments:
      'Selecciona alternativas fijas para cada elemento de una lista de datos dinámica',
    track_code: 'Permite asignar un código de seguimiento especifico para cada formulario',
    static_text: 'Permite agregar textos fijos como una instrucción del formulario',
    select_check_metadata: 'Selecciona múltiples elementos en una lista de datos dinámica',
    select_number_metadata: 'Selecciona un número para cada elemento de la lista de datos dinámica',
    select_text_metadata: 'Escribe un texto por cada elemento de una lista de datos dinámica',
    table: 'Crea un grupo de preguntas que puedes responder más de una vez',
  },
  types: {
    text: 'Texto',
    date: 'Fecha/Hora',
    number: 'Número',
    signature: 'Firma',
    barcode: 'Escáner',
    photo: 'Foto',
    multi_photo: 'Foto',
    multi_option: 'Selección Única',
    select_option_metadata: 'Checklist',
    select_option_metadata_comments: 'Checklist',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Número Lista Datos',
    select_text_metadata: 'Texto Lista Datos',
    static_text: 'Instrucción',
    select_metadata: 'Selección Lista Datos',
    table: 'Grupo de Preguntas Repetibles',
    attachment: 'Adjuntar Archivo',
    deprecated: 'Deprecada',
    select_activity_period_time: 'Actividad Lista Datos',
  },
  links: {
    appStore: 'https://itunes.apple.com/us/app/datascope-forms/id1132697668?l=es&ls=1&mt=8',
    playStore: 'https://app.datascope.io/apk',
    appLink: 'https://datascope.page.link/3N7P',
  },
  listManager: {
    dataListSource: 'Fuente de datos',
    name: 'Nombre',
    description: 'Descripción',
    code: 'Código',
    listItems: 'Elementos de la lista',
    emptyList: 'Esta lista no tiene elementos',
    attribute1: 'Atributo 1',
    attribute2: 'Atributo 2',
    listSubtitle:
      'Todas estas listas van a estar disponibles al momento de crear un nuevo formulario móvil',
    seeAll: 'Ver todas las listas',
    seeObj: 'Ver elementos de la lista',
    edit: 'Editar lista',
    editObj: 'Editar elemento',
    delete: 'Eliminar lista',
    deleteObj: 'Eliminar elemento',
    deleteObjectWarning: '¿Estás seguro/a de que quieres eliminar este elemento de la lista?',
    deleteYes: 'Sí, eliminar',
    saveChanges: 'Guardar',
    cancel: 'Cancelar',
    itemsOf: 'Elementos de:',
    addNewItem: '+ Nuevo elemento',
    page: 'Página ',
    of: ' de ',
    close: 'Cerrar',
    legacy: 'Ir al manejador de listas completo',
    locations: 'Lugares',
    assets: 'Activos',
  },
  locations: {
    planLimits: {
      actionBlocked1: 'Esta acción está bloqueada por los límites de tu plan actual.',
      actionBlocked2: 'Actualiza tu plan para desbloquearla.',
    },
    nestableLocationsBanner: {
      title: '¿Ya probaste los nuevos lugares?',
      description:
        'Crea listas de lugares jerárquicas para una operación más ordenada, precisa y con control de accesos. ',
      link: 'Crear lugares',
    },
    title: 'Lugares',
    searchPlaceholder: 'Buscar',
    header: {
      export: 'Exportar',
      import: 'Importar',
      createPlace: 'Crear lugar',
    },
    export: {
      success:
        'Lugares exportados con éxito. Enviaremos el archivo a tu correo electrónico apenas esté listo.',
      error:
        'Error al exportar lugares. Vuelve a intentarlo o contacta al soporte si el problema persiste.',
    },
    import: {
      title: 'Importar Lugares',
      description: 'Importar lugares desde un archivo Excel',
      step1Title: 'Paso 1: Descarga el archivo',
      step1Description:
        'Usa nuestra plantilla Excel para asegurarte de que tus lugares tengan el formato correcto',
      downloadExample: 'Descargar ejemplo',
      step2Title: 'Paso 2: Completa el Excel',
      step2Description: 'Agrega tus lugares y sublugares siguiendo el formato del ejemplo.',
      step3Title: 'Paso 3: Sube el archivo',
      step3Description: 'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora.',
      dragDropText: 'Arrastra y suelta tu archivo Excel aquí',
      browseText: 'o búscalo en tu computador',
      replaceText: 'Reemplazar',
      fileUploadedText: 'Tu archivo ha sido cargado',
      invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
      importError: 'Error al importar lugares',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      importingDescription: 'Un momento, estamos organizando todo...',
      errorTitle: 'Detectamos un error.',
      errorMessage: 'Por favor, verifica que tus datos tengan el formato correcto.',
      templateDownloadError: 'Error al descargar la plantilla',
      downloadingTemplate: 'Descargando...',
      templateUrl:
        'https://s3-us-west-2.amazonaws.com/data-scope/templates/nestable_locations/import_template_es_v1.xlsx',
      instructions: {
        maxSheets: 'El archivo debe contener no más de {maxSheets} hojas para anidación de lugares',
        maxRows: 'El archivo debe contener no más de {maxRows} filas por cada hoja',
        maxColumns: 'El archivo debe contener no más de {maxColumns} columnas por cada fila',
        maxLengthSheetName:
          'El nombre de la hoja debe tener no más de {maxLengthSheetName} caracteres',
        nestingSheetName:
          'El nombre de la hoja de anidación debe ser el del lugar al que se está anidando',
      },
      errors: {
        templateDownloadError: 'Error al descargar la plantilla',
        invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
        importError: 'Error al importar lugares',
        importButton: 'Importar',
        cancel: 'Cancelar',
        importing: 'Importando...',
        errorTitle: 'Detectamos un error.',
        errorMessage: 'Por favor, verifica que tus datos tengan el formato correcto.',
      },
    },
    table: {
      locationName: 'Nombre del lugar',
      users: 'Usuarios',
      lastActivity: 'Última actividad',
      actions: 'Acciones',
      resultsCount: 'Resultados: {start}-{end} de {total}',
      loadMore: 'Cargar más lugares',
      loadMoreError: 'Error al cargar más lugares. Por favor, inténtalo de nuevo.',
      noResults: 'No se encontraron resultados',
    },
    row: {
      location: 'Lugar',
      locations: 'Lugares',
      selected: 'seleccionado',
      selected_plural: 'seleccionados',
      address: 'Dirección: ',
      phone: 'Teléfono: ',
      viewLocation: 'Ver lugar',
      users: 'usuarios',
      today: 'Hoy',
      sublocation: 'Sublugar',
      sublocations: 'Sublugares',
      sublocationTooltip:
        'Para crear más sublugares necesitas un plan superior. Actualiza tu plan y desbloquea esta y otras funcionalidades',
      viewDetails: 'Ver detalles',
      edit: 'Editar',
      delete: 'Eliminar',
      view: 'Ver lugar',
    },
    create: {
      title: 'Crear lugar',
      success: 'Lugar creado exitosamente',
      error: 'Error al crear lugar',
    },
    update: {
      title: 'Actualizar lugar',
      success: 'Lugar actualizado exitosamente',
      error: 'Error al actualizar lugar',
    },
    form: {
      displayDescription: 'Información del lugar',
      createDescription: 'Crear nuevo lugar',
      updateDescription: 'Nuevo lugar',
      sections: {
        locationInfo: 'Información del lugar',
        contactInfo: 'Información de contacto',
        ubication: 'Ubicación',
      },
      name: {
        label: 'Nombre',
        placeholder: 'Ingresa el nombre del lugar...',
        required: 'El nombre del lugar es obligatorio',
        maxLength: 'El nombre debe tener 100 caracteres o menos',
      },
      type: {
        label: 'Tipo de lugar',
        required: 'El tipo de lugar es obligatorio',
        placeholder: 'Selecciona el tipo de instalación que estás creando...',
        options: {
          plant: 'Planta',
          enterprise: 'Empresa',
          warehouse: 'Bodega',
          production_line: 'Línea de producción',
          office: 'Oficina',
          branch: 'Sucursal',
          distribution_center: 'Centro de distribución',
          other: 'Otro',
        },
      },
      origin: {
        label: 'Lugar de origen',
        required: 'El origen del lugar es obligatorio',
        placeholder: 'Selecciona un lugar existente para asociar...',
        tooltip:
          'Al elegir un Lugar de origen este nuevo lugar se ubicará dentro de otro, formando parte de una estructura.',
        options: {
          main: 'Ubicación Principal',
          subsidiary: 'Subsidiaria',
          remote: 'Ubicación Remota',
          temporary: 'Ubicación Temporal',
          partner: 'Ubicación de Socio',
        },
      },
      phone: {
        label: 'Teléfono',
        placeholder: 'Ingresa el número de teléfono...',
        validation: {
          missingCountryCode: 'El número debe incluir el código de país (ej: +56)',
          invalidCountryCode: 'Código de país no válido',
          invalidFormat: 'Formato de número inválido',
          invalidLength: 'Longitud de número inválida para este país',
        },
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresa una descripción...',
        helper: 'Detalles opcionales para este lugar',
        validation: {
          tooLong: 'La descripción debe tener 100 palabras o menos.',
        },
      },
      users: {
        title: 'Usuarios y grupos',
        label: 'Usuarios',
        placeholder: 'Ingresa información de usuarios...',
        helper: 'Agrega información sobre los usuarios asignados a este lugar',
        showLess: 'Mostrar menos',
        showAll: 'Mostrar todos',
      },
      emails: {
        label: 'Emails',
        placeholder: 'Ingresa direcciones de correo...',
        helper: 'Agrega direcciones de correo relevantes para este lugar',
        inputHint: 'Separa los correos con comas o presiona Enter',
        validation: {
          tooMany: 'Máximo 5 direcciones de email permitidas.',
        },
      },
      coordinates: {
        latitude: {
          label: 'Latitud',
          invalid: 'La latitud debe estar entre -90 y 90.',
        },
        longitude: {
          label: 'Longitud',
          invalid: 'La longitud debe estar entre -180 y 180.',
        },
      },
      ubication: {
        label: 'Ubicación',
        search: 'Buscar dirección',
        hideMap: 'Ocultar mapa',
        showMap: 'Mostrar mapa',
        placeholder: 'Ingresa la dirección o coordenadas...',
        helper: 'Agrega la ubicación física, dirección o coordenadas',
        address: 'Dirección',
        city: 'Ciudad',
        region: 'Estado/Región',
        country: 'País',
        postalCode: 'Código Postal',
        noLocationsFound: 'No se encontraron ubicaciones',
      },
      buttons: {
        create: 'Crear',
        creating: 'Creando…',
        update: 'Actualizar',
        updating: 'Actualizando…',
        cancel: 'Cancelar',
      },
    },
    deleteConfirmation: {
      title: '¿Estás seguro que quieres eliminar este lugar?',
      message:
        'El lugar y todos sus sublugares se eliminarán, pero las respuestas, firmas y hallazgos no se perderán.',
      confirmButton: 'Eliminar',
      cancelButton: 'Cancelar',
      success: 'Lugar eliminado exitosamente',
      error: 'Error al eliminar el lugar',
    },
    emptyState: {
      noLocations: 'No se encontraron lugares',
      suggestion: 'Intente con diferentes palabras clave o revise su ortografía',
      noLocationsCreated: 'Aún no tienes lugares creados',
      createNewLocation: 'Crear un nuevo lugar',
      migration: {
        title: '¿Aún no has migrado tus lugares?',
        description:
          'Ahora puedes agrupar tus lugares por tipo y visualizar todo en un solo lugar.',
        button: 'Migrar mis lugares',
        close: 'Cerrar',
        imgAlt:
          'Representación de un trabajador con un calendario, un checklist y un PC flotando alrededor',
        viewTitle: 'Migra tus lugares a la nueva estructura',
        backButton: 'Volver a lugares',
        whyMigrate: '¿Por qué migrar?',
        reason1Title: 'Reúne en un solo lugar toda la actividad reciente:',
        reason1Description:
          'hallazgos, formularios completados, firmas, usuarios y grupos asociados.',
        reason2Title: 'Organiza tus espacios:',
        reason2Description:
          'agregando hasta cuatro subniveles por lugar, para representar cómo funcionan realmente tus sitios.',
        reason3Title:
          'Decide fácilmente qué usuarios o grupos pueden ver y trabajar en cada lugar.',
        reason3Description: 'Los usuarios sólo verán los lugares que les fueron asignados.',
        stepsTitle: 'Paso a paso para migrar tus lugares',
        step1Title: 'Usa tus lugares actuales como base',
        step1Description:
          'Descarga un Excel con los lugares que ya tienes en DataScope desde aquí y úsalo como base para completar la plantilla y ahorrar tiempo.',
        step2Title: 'Descarga la plantilla',
        step2Description:
          'Usa nuestra plantilla Excel para asegurarte de que tus lugares se carguen correctamente. En la primera hoja defines todos los lugares. Si necesitas jerarquía, crea hojas adicionales para asignar sublugares.',
        step3Title: 'Sube la nueva plantilla a la plataforma',
        step3Description:
          'Cuando completes la plantilla, impórtala aquí para actualizar tus lugares con la nueva estructura.',
        faqTitle: 'Preguntas frecuentes',
        faq1Question: '¿Qué va a pasar con mis lugares creados antes?',
        faq1Answer:
          'Los lugares antiguos seguirán funcionando por un tiempo. Próximamente comenzaremos un proceso gradual de cierre para dar paso a la nueva estructura de lugares.',
        faq2Question: '¿Puedo seguir accediendo a los lugares antiguos?',
        faq2Answer:
          '¡Sí! Vas a poder seguir accediendo a tus lugares antiguos. Se mantendrán en el mismo lugar, solo cambiarán de nombre a Lista (Lugares antiguos) para diferenciarlos de los nuevos.',
        faq3Question: '¿Mis formularios anteriores seguirán funcionando?',
        faq3Answer:
          'Sí, los formularios creados con lugares antiguos seguirán activos. En el constructor de formularios verás claramente diferenciados los lugares antiguos de los nuevos.',
        faq3Gif:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/old_locations_es.gif',
        faq4Question: '¿Cómo asigno lugares a los usuarios?',
        faq4Answer:
          'Para el caso de Lugares (nuevos) puedes asignar usuarios de manera individual desde la sección de Usuarios. Para asignaciones masivas, descarga y carga el Excel de usuarios.',
        faq5Question: '¿Puedo asociar un formulario a varios lugares?',
        faq5Answer:
          'Sí, siempre que los lugares estén en el mismo nivel jerárquico. No es posible asociar un formulario a lugares de distintos niveles.',
        faq6Question: '¿Puedo usar los lugares nuevos sin haber migrado todos los anteriores?',
        faq6Answer:
          'Sí, puedes migrar de manera parcial, siempre y cuando los lugares padre ya estén creados en la plataforma. Los lugares antiguos seguirán funcionando mientras completas la migración.',
        faq7Question: '¿Cómo identifico si un lugar ya fue migrado?',
        faq7Answer:
          'En la tabla de lugares podrás ver qué sublugares fueron migrados bajo cada lugar padre. Si ocurre algún error durante la migración, te lo notificaremos directamente en el proceso.',
        helpTitle: '¿Dudas o necesitas ayuda?',
        helpDescription:
          'Si tienes dudas sobre el proceso, contáctanos y te ayudamos a completar la migración.',
        helpButton: 'Solicitar ayuda',
        accessBanner: 'Todos los usuarios van a tener acceso a los lugares que migres',
        bannerImageUrl:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/location-migration-banner-es.png',
        modal: {
          title: 'Migrar tus lugares',
          step1: 'Paso 1: Usa tus lugares existentes como base',
          step1Description:
            'Si ya tienes lugares creados en DataScope, puedes descargarlos y usarlos como base para completar la plantilla.',
          downloadExistingButton: 'Descargar tus lugares existentes',
          downloading: 'Descargando...',
          step2: 'Paso 2: Descarga la plantilla',
          step2Description:
            'Usa el formato de la plantilla para asegurarte de que tus lugares se carguen correctamente.',
          downloadTemplateButton: 'Descargar la plantilla',
          step3: 'Paso 3: Sube tu archivo',
          step3Description:
            'Cuando tengas lista la plantilla, súbela aquí para migrar tus lugares.',
          cancel: 'Cancelar',
          migrateButton: 'Migrar lugares',
          migrating: 'Importando...',
          exportSuccess: 'Lugares exportados con éxito',
          exportError: 'Error al exportar lugares',
          helpAccordion: {
            title: '¿Cómo funciona la plantilla?',
            videoTitle: 'Video paso a paso',
            videoPlaceholder: '0:00 / 0:10',
            videoUrl: 'https://fast.wistia.net/embed/iframe/eusjtl1niy?web_component=true&seo=true',
            fileStructureTitle: 'Estructura del archivo:',
            fileStructure1: 'Hoja de importación:',
            fileStructure1Description:
              'Aquí importas todos tus lugares y sublugares desde un solo archivo.',
            fileStructure2: '¿Quieres que un lugar tenga sublugares?',
            fileStructure2Description:
              'En la columna Lugar de origen, escribe el lugar al que pertenecen.',
            fileStructure3: 'Recuerda completar los campos obligatorios:',
            fileStructure3Description: 'Nombre, Tipo de lugar y ubicación.',
            fileStructure4: 'Latitud y longitud obligatorias:',
            fileStructure4Description:
              'Puedes obtenerlas buscando la dirección en Google Maps o desde',
            fileStructure4Link: 'aquí',
            fileStructure4Note: 'Usa la misma ubicación para evitar errores al importar.',
            technicalLimitsTitle: 'Límites técnicos para importar:',
            technicalLimit1: 'Puedes importar hasta 2.500 lugares por archivo.',
          },
        },
      },
      utility: {
        title: 'Estructura y controla tu operación con lugares',
        preConfigTitle: '¿Para qué sirve lugares?',
        utilityTitle1: 'Centralizar la información:',
        utilityDescription1:
          'reúne en un solo lugar toda la actividad reciente, incluyendo hallazgos, formularios, firmas y usuarios.',
        utilityTitle2: 'Crear jerarquías de lugares:',
        utilityDescription2:
          'agrega hasta cuatro sublugares por lugar para representar la estructura real de tus operaciones.',
        utilityTitle3: 'Asignar accesos fácilmente:',
        utilityDescription3: 'define qué usuarios pueden ver y trabajar en cada lugar.',
      },
      reasons: {
        title: '¿Por qué usar lugares?',
        cardTitle1: 'Estructura flexible',
        cardDescription1:
          'Adapta los niveles de lugar a cómo funciona tu operación en el mundo real.',
        cardTitle2: 'Información por niveles y tipos',
        cardDescription2:
          'Puedes ver y gestionar formularios, hallazgos, usuarios y firmas asociadas a cada lugar.',
        cardTitle3: 'Asigna usuarios en cada lugar',
        cardDescription3: 'Asigna responsables usuarios a cada ubicación.',
      },
      carousel: {
        title: 'Crea tu primer lugar',
        gifAlt: 'Demostración gif para crear lugares',
        step1Title: 'Crear lugar',
        step1Description:
          'Crea un lugar presionando Crear lugar y define un nombre, un nivel de lugar, su tipo y si corresponde, asócialo a uno ya existente.',
        step2Title: 'Completa los datos',
        step2Description:
          'Añade un teléfono, correo y una breve descripción te ayudarán a identificarlo más adelante.',
        step3Title: 'Agrega la ubicación',
        step3Description:
          'Ingresa la dirección y detalles extra para identificar mejor este lugar en el mapa. Para finalizar presiona Crear.',
        nextStep: 'Siguiente',
        previousStep: 'Anterior',
      },
      legacy: {
        title: 'Lugares antiguos (Temporal)',
        description:
          'Puedes seguir accediendo a ellos desde aquí, aunque no son compatibles con todas las nuevas funcionalidades',
        button: 'Ver lugares antiguos',
      },
      createNewTitle: 'Crea una nueva forma de organizar tu operación',
      oldLocationsTitle: 'Tus lugares son antiguos.',
      oldLocationsDescription: 'Crea nuevos y aprovecha los beneficios',
      createButton: 'Crear lugares',
      noLocationsAvailable: 'No hay ubicaciones disponibles',
      searchPlaceholder: 'Buscar ubicaciones...',
      loadingLocations: 'Cargando ubicaciones...',
    },
  },
  tasksForms: {
    activateScroll: 'Activar scroll en la app',
    disableScroll: 'Desactivar scroll en la app',
    scrollActiveSuccess: 'Scroll activado con éxito',
    scrollDisabledSuccess: 'Scroll desactivado con éxito',
    templates: 'Plantillas de formularios',
    useTemplate: 'Usar plantilla',
    newVersion: 'Cambiar a nueva versión',
    oldVersion: 'Cambiar a versión antigua',
    uniq: 'El nombre de la pregunta debe ser único',
    title: 'Formularios',
    preview: 'Vista previa',
    export: 'Exportar',
    export_help: 'Puedes copiar este código fuente y pegarlo en otro formulario',
    import: 'Importar',
    import_confirm: '¿Estás seguro de que quieres importar este formulario?',
    import_success: 'Se está importando su formulario, puede tardar algunos minutos',
    importSuccessSync: 'Tu formulario se importó correctamente',
    start_testing: '¡Es momento de probar tu formulario nuevo!',
    test_button: 'Probar formulario',
    start_testing_desc:
      'Felicitaciones, ya tienes tu primer formulario. Ahora puedes probarlo y mandar tu primera respuesta desde la app móvil.',
    import_error:
      'No se pudo importar el formulario. Compruebe si es un formulario válido o si ya está importado.',
    clone: 'Duplicar',
    default_title: 'Mi Formulario',
    default_question: 'Pregunta',
    drag_questions:
      'Por el momento no tienes preguntas en el formulario, arrastra tus preguntas acá',
    new: 'Nuevo formulario',
    new_ai: 'Formulario con IA',
    google_forms: 'Importar Google Form',
    are_you_sure: '¿Estas seguro?',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    publish: 'Activar',
    unpublish: 'Desactivar',
    last_info: 'Agregar HTML al final del PDF',
    current_logo: 'Logo del Formulario',
    form_logo: 'Logo Formulario',
    form_name: 'Nombre',
    actions: 'Configurar',
    answer_form: 'Responder',
    edit_app: 'Configurar App',
    edit_pdf: 'Configurar PDF',
    edit_email: 'Configurar Email',
    edit_share: 'Compartir',
    error_form: 'Ha ocurrido un error',
    success_form: 'Éxito',
    delete: 'Eliminar',
    date: 'Fecha/Hora',
    date_type: 'Tipo Fecha',
    date_type_date: 'Fecha',
    date_type_datetime: 'Fecha y Hora',
    date_type_time: 'Hora',
    text: 'Texto',
    number: 'Número',
    multi_option: 'Selección Única',
    signature: 'Firma',
    barcode: 'Escáner',
    photo: 'Foto',
    select_metadata: 'Selección Lista Datos',
    select_option_metadata: 'Checklist',
    track_code: 'Código de seguimiento',
    static_text: 'Texto Fijo',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Número Lista Datos',
    select_text_metadata: 'Texto Lista Datos',
    table: 'Grupo de Preguntas Repetibles',
    name: 'Título Pregunta',
    description: 'Descripción Pregunta',
    label: 'Nombre Sección',
    choices: 'Alternativas',
    choice: 'Alternativa',
    add_choice: 'Agregar Opción',
    add_list_value: 'Agregar Valor Lista',
    add_question: 'Agregar Pregunta',
    list_values: 'Valores Lista',
    delete_choice: 'Eliminar Opción',
    drop_question: 'Arrastrar preguntas repetibles aquí',
    metadata_type: 'Fuente Lista Datos',
    create_metadata: 'Nueva Lista de Datos',
    change_metadata: 'Cambiar Lista de Datos',
    save_form: 'Guardar Formulario',
    version: 'versión',
    no_name: 'Sin Nombre',
    no_questions: 'Debe tener al menos una pregunta',
    no_data: 'No hay formularios disponibles',
    blank_table: 'Sub Formulario debe tener al menos una pregunta',
    sub_questions: 'Sub Preguntas',
    disable_gallery: 'Deshabilitar Galería',
    required: 'Obligatorio',
    back: 'Atrás',
    location: 'Lista de Lugares',
    help_title: '¿Necesitas Ayuda para crear formulario?',
    help_instruction: 'Solicitar creación de formulario',
    help_description:
      '"***Por favor explicar la información que deseas levantar y cada pregunta del formulario. Adjunta una foto o documento de este mismo"',
    example_title_1: 'Construya sus propios formularios digitales',
    example_description_1:
      'Con el Form Builder puede crear formularios perfectos. Es fácil, intuitivo y potente.',
    success_created: 'El formulario se creó correctamente.',
    hide_logic: 'Saltar preguntas',
    show_price: 'Mostrar Precio',
    show_avg: 'Mostrar Promedio',
    show_factor: 'Mostrar Multiplicación',
    show_percent: 'Mostrar Porcentaje',
    equal: 'Igual',
    not_equal: 'Diferente',
    if: 'SI',
    is: 'ES',
    to: 'A',
    go_to: 'IR A',
    next_question: 'Siguiente Pregunta',
    finish_form: 'Terminar Formulario',
    standard_pdf: 'PDF Estándar',
    customized_pdf: 'PDF Personalizado',
    open_editor: 'Abrir Editor PDF',
    own_pdf: 'Cree su propio diseño PDF',
    need_your_pdf: '¿Necesita su propio diseño PDF?',
    pdf_description:
      'El creador de PDF más flexible para crear sus propios documentos con los datos recopilados',
    folders: 'Carpetas',
    manage_folders: 'Nueva carpeta',
    manage_states: 'Ver estados',
    view_all_folders: 'Ver todas las carpetas',
    searchSend: 'Buscar',
    searchForm: 'Buscar formularios...',
    custom_pdf: {
      step1: 'Crear Plantilla',
      step1_desc:
        'Debes crear una plantilla usando el editor de PDF. Puedes utilizar todos los valores de respuestas del formulario. Se utilizaran los datos del último formulario a modo de ejemplo.',
      step2: 'Activar Plantilla',
      step2_desc:
        'Una vez que la plantilla este lista, puedes activarla. Una vez activado todas las exportaciones se generarán con el formato especificado previamente.',
    },
    help: {
      multi_option: 'Selecciona una alternativa en una lista de elementos',
      select_metadata:
        'Selecciona una alternativa dentro de una lista de datos dinámica ( Ej. Productos, Clientes, etc..)',
      select_option_metadata:
        'Selecciona alternativas fijas para cada elemento de una lista de datos dinámica',
      track_code: 'Permite asignar un código de seguimiento especifico para cada formulario',
      static_text: 'Permite agregar texto fijo como instrucción del formulario',
      select_check_metadata:
        'Permite hacer un check de múltiples elementos dentro de una lista de datos dinámica',
      select_number_metadata:
        'Selecciona un número para cada elemento de una lista de datos dinámica',
      select_text_metadata: 'Selecciona texto para cada elemento de una lista de datos dinámica',
      table: 'Crear un grupo de preguntas que se pueden responder más de una vez',
      description:
        '"Texto más extenso para mostrar en la App. No aparece al exportar datos. (Opcional)"',
      title: 'Título corto para identificar pregunta. Aparece al exportar datos.',
    },
    share: {
      title: 'Generar Link Google Forms',
      link: 'Link:',
      edit_link: 'Editar Google Form',
      export: 'Exportar Google Form',
      sendgrid_template_id: 'd-e6004a145c78496a8d02f26600dec5e0',
      inactive_public_form: 'Este formulario ya no es accesible usando este link.',
      success_message: 'Hemos recibido tu respuesta correctamente',
      make_form_private: 'Eliminar acceso público al formulario',
      make_form_private_notice:
        'Este formulario ahora es privado. Los enlaces públicos previamente compartidos han dejado de ser válidos.',
      make_form_public: 'Hacer público este formulario',
      make_form_public_notice:
        'Este formulario ahora es público. ¡Ahora puede compartirlo con personas ajenas a su organización!',
      share_via_email: 'Comparte este formulario mediante un email',
      share_email_tooltip:
        'Se enviará un enlace público, accesible a cualquier persona, a aquellos correos electrónicos que no estén asociados a esta cuenta. Se enviará un enlace de uso privado a aquellos correos electrónicos que pertenezcan a usuarios registrados de esta cuenta.',
      share_whatsapp_message: 'Hola, te invito a responder el siguiente formulario DataScope: ',
      share_public_link: 'Comparte este formulario mediante un link público',
      share_public_link_tooltip:
        'Cualquier persona, tanto usuarios registrados como no registrados, podrá completar este formulario si comparte el enlace público con ellos. Sus respuestas quedarán registradas a nombre de un usuario genérico, webforms_user_',
      share: 'Compartir',
      copy: 'Copiar',
      trigger: 'Trigger no instalado. Límite de 20 Alcanzado.',
      loading: 'Cargando Formulario...',
      failed: 'Exportación de Formulario Fallida.',
      auth: "'TIP: 'Si tiene problemas, intente cerrar las sesiones de Google (por ejemplo, en google.com), y luego ingrese sólo con la cuenta a la que quiere exportar el formulario.'",
      add_all_permissions: 'Agregar este formulario a todos los usuarios',
      permission_success:
        'Permiso agregado para todos los usuarios, debe cerrar la sesión y volver a iniciar en la aplicación para actualizar los formularios',
    },
    delete_form_confirm: '¿Estás seguro que quieres eliminar este formulario?',
    delete_form_warning: 'Una vez que lo elimines, no podrás recuperarlo.',
    delete_form_success: 'Formulario eliminado con éxito',
    delete_form_failure: 'Error al eliminar el formulario',
    clone_form_success: 'Formulario clonado con éxito',
    clone_form_failure: 'Error al clonar el formulario',
    publish_form_success: 'Formulario activado con éxito',
    publish_form_failure: 'Error al activar el formulario',
    unpublish_form_success: 'Formulario desactivado con éxito',
    unpublish_form_failure: 'Error al desactivar el formulario',
    rename: 'Renombrar',
    rename_folder: 'Renombrar carpeta',
    folder_name: 'Nombre de la carpeta',
    new_name: 'Nuevo nombre',
    update: 'Actualizar',
    cancel: 'Cancelar',
    rename_success: 'Carpeta renombrada con éxito',
    rename_failure: 'Error al renombrar la carpeta',
    delete_folder_confirm: '¿Estás seguro que quieres eliminar la carpeta ',
    delete_warning:
      'Una vez que la elimines, estos formularios pasarán a la sección de formularios (sin carpeta).',
    delete_folder_success: 'Carpeta eliminada con éxito',
    delete_folder_failure: 'Error al eliminar la carpeta',
    move_to_folder: 'Mover a carpeta',
    lockEditing: 'Bloquear edición',
    unlockEditing: 'Habilitar edición',
    unlockEditingSuccess: 'Formulario habilitado exitosamente para edición',
    unlockEditingFailure: 'Error al habilitar el formulario para edición',
    editingLocked: 'Edición bloqueada',
    editingLockedBy: 'Edición bloqueada por:',
    unknownUser: 'Usuario desconocido',
    lockEditingConfirmModal: {
      title: 'Bloquear edición de formulario',
      message:
        'Si lo bloqueas, nadie más podrá editar este formulario. Solo tú o soporte podrán desbloquearlo.',
      confirmButton: 'Bloquear',
      cancelButton: 'Cancelar',
      successMessage: 'Formulario bloqueado exitosamente para edición',
      failureMessage: 'Error al bloquear el formulario para edición',
    },
    remove_from_folder: 'Remover de carpeta',
    move: 'Mover',
    warn_empty_folder: 'Esta acción eliminará la carpeta al quedar esta vacía.',
    move_form_success: 'Formulario movido exitosamente',
    move_forms_success: 'Formularios movidos exitosamente',
    move_form_failure: 'Error al intentar mover el formulario',
    move_forms_failure: 'Error al intentar mover los formularios',
    create: 'Crear',
    create_form_folder: 'Crear carpeta de formularios',
    create_folder_success: 'Carpeta creada con éxito',
    create_folder_failure: 'Error al crear la carpeta',
    how_to_create_folder: '¿Cómo quieres crear tu carpeta?',
    next: 'Siguiente',
    form_selection: 'Selección formularios',
    no_forms_available: 'No tienes formularios disponibles en este momento',
    forms: 'Formularios',
    form: 'formulario',
    bulk_action: {
      publish: {
        confirm: '¿Estas seguro que quieres activar',
        info: 'Una vez los actives, los podrás volver a desactivar.',
        success: 'Formularios activados con éxito',
        failure: 'Error al activar los formularios',
      },
      unpublish: {
        confirm: '¿Estas seguro que quiere desactivar',
        info: 'Una vez los desactives, los podrás volver a activar.',
        success: 'Formularios desactivados con éxito',
        failure: 'Error al desactivar los formularios',
      },
      delete: {
        confirm: '¿Estas seguro que quieres eliminar',
        info: 'Una vez los elimines, no los podrás volver a recuperar.',
        success: 'Formularios eliminados con éxito',
        failure: 'Error al intentar eliminar los formularios',
      },
    },
    configure_signature: 'Configurar firma electrónica',
    formResults: 'Resultados: ',
    formResultsOf: 'de',
    current_folder: 'Carpeta actual:',
    formLimitReachedTooltip: 'Alcanzaste el límite de formularios permitidos. ',
    upgradePlanTooltipLink: 'Actualiza tu plan',
    upgradePlanTooltip: ' para crear formularios',
    importPermissionError: 'No tienes permisos para importar plantillas de formularios.',
    projectLimitReachedError:
      'No se pudo importar el formulario. Has alcanzado el número máximo de formularios permitidos.',
    folder: 'Carpeta',
    new_form_create: 'Formulario',
    form_ai: 'Formulario con IA',
    forms_limit: {
      title: 'Límite de formularios alcanzado',
      description:
        'Has alcanzado el límite de 3 formularios en tu plan actual. Para crear más formularios, actualiza tu plan y accede a más funciones:',
      benefit1: 'Formularios ilimitados',
      benefit2: 'Más opciones de personalización',
      benefit3: 'Mayor capacidad de almacenamiento',
      confirm: 'Desbloquea más formularios ahora',
      cancel: 'Seguir con versión gratuita',
      confirm_chat_message: 'Hola, necesito crear más formularios. ¿Cómo puedo actualizar mi plan?',
    },
  },
  mobileUsers: {
    users: 'Usuarios',
    new: 'Crear Usuario',
    import: 'Importar',
    import_users: 'Importar Usuarios',
    how_import: '¿Cómo importar usuarios?',
    bulk_actions: 'Acciones Masivas',
    add_users_to_group: 'Agregar usuarios a grupo',
    deactivate_users: 'Deshabilitar usuarios',
    add: 'Agregar',
    add_to_group: 'Agregar a grupo',
    selectAGroup: 'Selecciona un grupo',
    duplicate_user:
      'Ya existe un usuario eliminado con el mismo correo electrónico. Por favor, reactive ese usuario en su lugar',
    identifier_help: 'Necesario para iniciar sesión en el dispositivo móvil',
    advanced: 'Configuración Avanzada',
    old_password_required:
      'no es válido. Para cambiar la contraseña de administrador se requiere confirmación.',
    group_users: 'Grupos de Usuarios',
    group_new: 'Crear Grupo',
    you: 'usted',
    location_perm: 'Permisos a lugares',
    forms_perm: 'Permisos a formularios',
    activated: 'Activos',
    deactivated: 'Desactivados',
    modifications_history: 'Historial',
    noGroups: 'No tienes grupos de usuarios',
    infoNotice:
      'Los usuarios solo podrán ver los formularios y respuestas que les correspondan según su grupo.',
    delete_group: 'Eliminar grupo',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    rename: 'Renombrar',
    rename_group: 'Renombrar grupo',
    group_name: 'Nombre del grupo',
    new_name: 'Nombre nuevo',
    update: 'Actualizar',
    confirm_group_delete: '¿Estás seguro que quieres eliminar el grupo ',
    confirm_group_delete2:
      'Una vez lo elimines, los usuarios que no estén en otros grupos quedarán sin grupo y tendrán los permisos individuales previamente asignados.',
    update_groups_success: 'Cambios realizados con éxito',
    update_groups_error: 'Ocurrió un error al guardar los cambios',
    userInfo: 'Información del usuario',
    userGroupsHelp: 'Este usuario pertenece a los siguientes grupos:',
    manageGroupModalTitle: 'Permisos en',
    searchForm: 'Buscar formulario...',
    searchUser: 'Buscar usuario...',
    groupUpdateSuccess: 'Grupo actualizado exitosamente',
    permissions_title: 'Permisos',
    forms_title: 'Formularios',
    group_name_exists: 'Un grupo con ese nombre ya existe',
    edit_group_permissions: 'Permisos formularios',
    edit_groups: 'Agregar a grupo',
    save: 'Guardar',
    editGroupsInfo:
      'Los usuarios asignados a uno o varios grupos, obtendrán permisos para acceder a los formularios de esos grupos. En consecuencia, no podrán tener formularios asignados de manera individual al mismo tiempo.',
    modifiedGroup: 'Grupo modificado',
    modificationAuthor: 'Modificado por',
    modificationDate: 'Fecha',
    modification: 'Modificación',
    added: 'Agregados',
    removed: 'Eliminados',
    group: 'Grupo',
    createdGroup: 'Grupo creado',
    deletedGroup: 'Grupo eliminado',
    renamedGroup: 'Grupo renombrado',
    emptyHistory: 'No hay historial de modificaciones',
    previousName: 'Nombre anterior',
    assetAssigned: 'Permiso asignado al activo',
    assetRemoved: 'Permiso removido del activo',
    removeFromGroup: 'Eliminar del grupo',
    remove: 'Remover',
    removeUsersConfirm: '¿Estás seguro que quieres remover',
    removeUsersConfirm2: 'usuario(s) del grupo',
    onceUsersRemoved:
      'Una vez los remuevas, estos pasarán a usuarios sin grupo o quedarán en los otros grupos a los que pertenecen.',
    noUsersInGroup: 'Aún no has agregado usuarios a este grupo',
    searchGroups: 'Buscar grupos...',
    pendingConfirmationTitle: 'Confirmación pendiente',
    pendingConfirmationSubtitle: 'Comparte este enlace solo con este usuario',
    copy: 'Copiar',
    linkCopied: 'Enlace copiado!',
    resendInvitation: 'Reenviar',
    deleteGroupPendingSignatureError: 'Grupo contiene usuarios con firmas pendientes',
    invite_user: {
      title: 'Invitar Usuarios',
      placeholder: 'ejemplo@ejemplo.com',
      help: 'Si quieres cambiar los permisos, da clic en configurar permisos',
      btn: 'Invitar',
      config: 'Configurar Permisos',
      successSingular: 'Invitación enviada exitosamente',
      successPlural: 'Invitaciones enviadas exitosamente',
      error:
        'No se pudo invitar a los usuarios, verifique que los correos electrónicos sean válidos y no se hayan utilizado antes',
      emailFormatError: 'Formato de correo incorrecto, por favor utilice ejemplo@ejemplo.com',
      emails: 'Emails',
    },
    permissions: {
      answers: 'Ver respuestas de formularios',
      evaluate: 'Cambiar Estado Respuestas Formularios',
      chat: 'Chatear',
      tasks: 'Responder Formularios',
      assigned: 'Ver Formularios Asignados',
      users: 'Mostrar y crear nuevos usuarios',
      export: 'Exportar Datos',
      metadata: 'Crear Listas Personalizadas',
      modify: 'Modificar Respuestas de Formularios',
      edit_forms: 'Editar Formularios',
      evaluate_delete: 'Eliminar/Recuperar Respuestas Formularios',
      access_to_charts: 'Acceso a gráficos',
      admin_account_config: 'Administrar la configuración de la cuenta',
      admin_signatures: 'Administrar firmas',
      admin_findings: 'Administrar {{finding_label}}s',
      admin_assets: 'Administrar activos',
      admin_places: 'Administrar lugares',
      assign_new_places: 'Asignar automáticamente nuevos lugares',
    },
    roles: {
      customized: 'Customizado',
      administrator: 'Administrador',
      superadmin: 'Administrador Principal',
      supervisor: 'Supervisor',
      editing_operator: 'Operario editor',
      operator: 'Operario',
    },
    table: {
      name: 'Nombre',
      user: 'Usuario',
      role: 'Rol',
      lastConnection: 'Última conexión',
      noLastConnection: 'Última conexión no disponible',
      actions: 'Acciones',
      configure: 'Configurar',
      edit: 'Editar',
      deactivate: 'Deshabilitar',
      activate: 'Habilitar',
      no_data: 'No hay usuarios disponibles',
      groups: 'Grupos',
      viewMore: 'Ver más',
      noForms: 'Este grupo de usuarios no tiene formularios asignados',
      not_confirmed: 'Confirmación Pendiente',
    },
    logs: {
      user: 'Usuario modificado',
      author: 'Autor de la modificación',
      date: 'Fecha',
      modification: 'Modificación',
      activated: 'Reactivado',
      deactivated: 'Eliminado',
    },
    deactivation: {
      cancel: 'Cancelar',
      confirmationTitle: '¿Estás seguro que quieres deshabilitar este usuario?',
      confirmationMessage:
        'Los datos no se perderán, luego podrás volverlo a activar en usuarios inactivos.',
      bulkConfirmationTitle: '¿Estás seguro que quieres deshabilitar',
      bulkConfirmationMessage:
        'Los datos no se perderán, luego podrás volverlos a activar en usuarios inactivos.',
      success: 'Usuario(s) desactivado(s) exitosamente',
      error: 'Ocurrió un error al desactivar los usuario(s)',
    },
    createUser: {
      information: {
        title: 'Información',
        name: 'Nombre',
        lastName: 'Apellido',
        email: 'Email',
        example: 'ejemplo@ejemplo.com',
        password: 'Contraseña',
        passwordHelper: 'La contraseña debe tener al menos 6 caracteres',
        phone: 'Teléfono',
      },
      group: {
        title: 'Grupo',
        selectHelper: 'Selecciona un grupo existente (Puedes seleccionar varios)',
        noGroup: 'Sin grupo',
        newGroup: 'Nuevo grupo',
        newGroupHelper: 'Escribe el nombre del grupo',
        newGroupSuccess: 'Nuevo grupo creado con éxito!',
        newGroupError: 'Ocurrió un error creando el nuevo grupo',
        configuration: 'Debes configurar permisos a formularios para este grupo',
        formsHelp: 'Formularios a los que tendrá acceso este usuario:',
        cantEditPermissions:
          'No puedes cambiar tus propios permisos de grupos. Pide a otra persona que lo haga si deseas modificarlos.',
      },
      forms: {
        title: 'Formularios',
        allForms: 'Formularios',
        addForm: 'Agregar formulario',
        formsHelper: 'Podrás ver los formularios y las respuestas de los seleccionados.',
        formsHelperDisabled: 'Podrás ver estos formularios y sus respuestas.',
        formsGroupHelper:
          'Los formularios y lugares a los que tendrá acceso este usuario son los pertenecientes a el/los grupos previamente elegidos.',
        seeMore: 'ver más',
        groupsAlert:
          'No puedes agregar formularios porque asignaste o creaste un grupo previamente',
        back: 'Atras',
        folders: 'Carpetas',
        close: 'Cerrar',
        formHasPendingSignature:
          'Este usuario tiene firmas pendientes. Mientras no se respondan o eliminen no podrás modificar los permisos.',
        massSelectionBlockedByPendingSignature:
          'Selección masiva de formularios bloqueada por firmas pendientes.',
        foldersBlockedByPendingSignature:
          'Selección de carpetas bloqueada por firmas pendientes. Abre la carpeta para seleccionar formularios.',
        cantEditPermissions:
          'No puedes cambiar tus propios permisos de formularios. Pide a otra persona que lo haga si deseas modificarlos.',
      },
      permissions: {
        title: 'Permisos',
        editingMyself:
          'No puedes cambiar tus propios permisos. Pide a otra persona que lo haga si deseas modificarlos.',
        basic: {
          title: 'Básico',
          viewFormAnswers: 'Ver respuestas de formularios',
          chat: 'Chatear',
          submitFormAnswers: 'Responder formularios',
          viewAssignedForms: 'Ver formularios asignados',
        },
        advanced: {
          title: 'Avanzado',
          changeFormStatus: 'Cambiar estado de formularios',
          createMetadata: 'Crear listas personalizadas',
          editFormAnswers: 'Modificar respuestas de formularios',
          editForms: 'Editar formularios',
          evaluateDelete: 'Eliminar y recuperar respuestas de formularios',
          accessToCharts: 'Acceso a gráficos',
          assignNewPlaces: 'Asignar automáticamente nuevos lugares',
        },
        admin: {
          title: 'Administración',
          viewAndCreateUsers: 'Mostrar y crear nuevos usuarios',
          exportData: 'Exportar datos',
          adminAccountConfig: 'Administrar la configuración de la cuenta',
          adminSignatures: 'Administrar firmas',
          adminFindings: 'Administrar {{finding_label}}s',
          adminAssets: 'Administrar activos',
          adminPlaces: 'Administrar lugares',
        },
        editFormsTooltip1: 'Este usuario no tiene permiso para editar formularios. ¡',
        editFormsTooltipLink: 'Actualiza tu plan',
        editFormsTooltip2: ' ahora y desbloquea la productividad sin límites!',
      },
      locations: {
        title: 'Lugares (Opcional)',
        helper:
          'Si activas esta opción, el usuario sólo podrá ver los formularios asociados a los lugares que selecciones',
        locations: 'Lugares',
        andOthers: ', y otros...',
        cantEditPermissions:
          'No puedes cambiar tus propios permisos de lugares. Pide a otra persona que lo haga si deseas modificarlos.',
        allLocationsAccessBanner:
          'Este usuario tiene acceso a todos los lugares ya creados. Si quieres restringir los lugares que puede ver, deberás seleccionarlos manualmente desde esta sección.',
        allNewLocationsAccessBadge: 'Acceso a todos los lugares nuevos',
      },
      signature: {
        name: 'Nombre completo',
        companyName: 'Nombre sociedad',
        pronoun: 'Tu',
        userIdNumber: {
          default: 'Número de identificación',
          CL: 'RUT',
          PE: 'DNI',
          MX: 'CURP/RFC',
          CO: 'CC',
          AR: 'DNI',
          PY: 'CI',
          ES: 'DNI/NIE',
          BR: 'CPF',
          UY: 'CI',
          BO: 'CI',
          EC: 'Cédula',
          VE: 'Cédula de identidad',
          US: 'SSN/DL/PP/ID',
          CA: 'SIN',
          DO: 'Cédula de identidad y electoral',
          CR: 'Cédula',
          PA: 'Cédula',
          GT: 'DPI',
          SV: 'DUI',
          HN: 'DNI',
          NI: 'Cédula',
          PR: 'SSN',
          CU: 'CI',
          JM: 'TRN',
          PT: 'NIF',
          FR: 'INSEE',
          DE: 'Personalausweisnummer/Steuer-ID',
          IT: 'Codice Fiscale',
          GB: 'Número de Seguro Nacional',
          IE: 'Número PPS',
          NL: 'BSN',
          BE: 'Número Nacional',
          CH: 'Número AHV',
          AT: 'Número de Seguridad Social',
          SE: 'Número Personal',
          NO: 'ID Nacional',
          DK: 'Número CPR',
          FI: 'Código de Identidad Personal',
          IS: 'Kennitala',
          PL: 'PESEL',
          CZ: 'Número de Nacimiento',
          SK: 'Número de Nacimiento',
          HU: 'Número Tributario',
          RO: 'CNP',
          BG: 'EGN',
          GR: 'AMKA/AFM',
          HR: 'OIB',
          SI: 'EMSO',
          RS: 'JMBG',
          BA: 'JMBG',
          ME: 'JMBG',
          MK: 'EMBG',
          MT: 'Tarjeta de ID',
          CY: 'Número de ID',
          LU: 'ID Nacional',
          LT: 'Código Personal',
          LV: 'Código Personal',
          EE: 'Código Personal',
          TR: 'TC Kimlik No',
          IL: 'Número de ID',
          SA: 'ID Nacional',
          AE: 'Emirates ID',
          QA: 'QID',
          KW: 'ID Civil',
          BH: 'CPR',
          OM: 'ID Civil',
          JO: 'ID Nacional',
          LB: 'Número de ID',
          EG: 'ID Nacional',
          MA: 'CIN',
          TN: 'CIN',
          DZ: 'ID Nacional',
          ZA: 'Número de ID',
          NG: 'NIN',
          KE: 'Número de ID',
          GH: 'Ghana Card',
          UG: 'ID Nacional',
          TZ: 'NIDA',
          RW: 'ID Nacional',
          BW: 'Omang',
          NA: 'Número de ID',
          ZM: 'NRC',
          ZW: 'ID Nacional',
          ET: 'ID Nacional',
          CN: 'ID Nacional',
          IN: 'Aadhaar',
          PK: 'CNIC',
          BD: 'NID',
          JP: 'My Number',
          KR: 'RRN',
          SG: 'NRIC/FIN',
          MY: 'MyKad',
          ID: 'KTP',
          PH: 'UMID',
          TH: 'ID Nacional',
          VN: 'CCCD',
          HK: 'HKID',
          TW: 'ID Nacional',
          LK: 'NIC',
          NP: 'ID Nacional',
          AU: 'TFN/Medicare',
          NZ: 'Número IRD',
          RU: 'SNILS',
          UA: 'Número Tributario',
          BY: 'ID Nacional',
          KZ: 'IIN',
          UZ: 'PINFL',
          GE: 'Número Personal',
          AM: 'Tarjeta Social',
          AZ: 'FIN',
        },
        country: 'País',
        selectCountry: 'Selecciona un país',
        noResults: 'No se encontraron países',
        userEmail: 'Email personal',
        legalRepresentative: 'Representante legal',
        companyIdNumber: {
          default: 'Número de identificacion tributaria',
          CL: 'RUT',
          PE: 'RUC',
          MX: 'RFC',
          CO: 'NIT',
          AR: 'CUIT',
          PY: 'RUC',
          ES: 'NIF',
          BR: 'CNPJ',
          UY: 'RUT',
          BO: 'NIT',
          EC: 'RUC',
          VE: 'RIF',
          US: 'EIN',
          CA: 'BN',
          DO: 'RNC',
          CR: 'Cédula Jurídica',
          PA: 'RUC',
          GT: 'NIT',
          SV: 'NIT',
          HN: 'RTN',
          NI: 'RUC',
          PR: 'EIN',
          CU: 'NIT',
          JM: 'TRN',
          PT: 'NIPC',
          FR: 'SIREN',
          DE: 'Número Tributario',
          IT: 'Partita IVA',
          GB: 'Número',
          IE: 'Número',
          NL: 'KvK',
          BE: 'BCE/KBO',
          CH: 'UID',
          AT: 'Número Tributario',
          SE: 'Número Org',
          NO: 'Número Org',
          DK: 'CVR',
          FI: 'Y-tunnus',
          IS: 'Kennitala',
          PL: 'NIP',
          CZ: 'IČO',
          SK: 'IČO',
          HU: 'Número Tributario',
          RO: 'CUI',
          BG: 'UIC',
          GR: 'AFM',
          HR: 'OIB',
          SI: 'Número Tributario',
          RS: 'PIB',
          BA: 'Número Tributario',
          ME: 'Número Tributario',
          MK: 'Número Tributario',
          MT: 'Número IVA',
          CY: 'Número Tributario',
          LU: 'Número Tributario',
          LT: 'Código',
          LV: 'Número',
          EE: 'Código',
          TR: 'Número Tributario',
          IL: 'Número',
          SA: 'Número CR',
          AE: 'Licencia Comercial',
          QA: 'Número CR',
          KW: 'Número CR',
          BH: 'Número CR',
          OM: 'Número CR',
          JO: 'Número Tributario',
          LB: 'Número Tributario',
          EG: 'Número Tributario',
          MA: 'RC',
          TN: 'Número Tributario',
          DZ: 'NIS',
          ZA: 'Número',
          NG: 'Número RC',
          KE: 'PIN',
          GH: 'TIN',
          UG: 'TIN',
          TZ: 'TIN',
          RW: 'TIN',
          BW: 'Número Tributario',
          NA: 'Número Tributario',
          ZM: 'TPIN',
          ZW: 'Número Tributario',
          ET: 'TIN',
          CN: 'USCI',
          IN: 'CIN',
          PK: 'NTN',
          BD: 'TIN',
          JP: 'Número',
          KR: 'Número de Registro',
          SG: 'UEN',
          MY: 'Número SSM',
          ID: 'NPWP',
          PH: 'TIN',
          TH: 'ID Tributario',
          VN: 'Código Tributario',
          HK: 'Número BR',
          TW: 'UBN',
          LK: 'Número BRC',
          NP: 'PAN',
          AU: 'ABN',
          NZ: 'NZBN',
          RU: 'INN',
          UA: 'EDRPOU',
          BY: 'UNP',
          KZ: 'BIN',
          UZ: 'Número Tributario',
          GE: 'Número Tributario',
          AM: 'Número Tributario',
          AZ: 'Número Tributario',
        },
        companyLabel: 'empresa',
        address: 'Dirección',
        companyEmailError: 'Debes usar un correo electrónico diferente',
        userIdNumberError: 'inválido',
        userIdNumberSuccess: 'ha sido verificado',
        companyIdNumberError: 'inválido',
        companyIdNumberSuccess: 'ha sido verificado',
      },
      cancel: 'Cancelar',
      save: 'Guardar',
      success: 'Nuevo usuario creado con éxito!',
      error: 'Ocurrió un error creando el usuario',
    },
    editUser: {
      information: {
        oldPassword: 'Contraseña actual',
        newPassword: 'Contraseña nueva',
        passwordChange: 'Cambiar contraseña',
        error: 'Ocurrió un error actualizando el usuario',
        success: 'Usuario actualizado con éxito!',
      },
    },
    createGroup: {
      button: 'Crear grupo',
      title: 'Crear grupo de usuarios',
      chooseHeader: '¿Cómo quieres crear el grupo?',
      name: 'Nombre grupo',
      nameHelper: 'Nombre del grupo',
      userSelection: 'Selección usuarios',
      formSelection: 'Selección formularios',
      importExcelNote: '*Luego tendrás que asignarle permisos a formularios',
      warning:
        'Los usuarios asignados a un grupo accederán a los formularios de ese grupo y no podrán tener formularios asignados de manera individual al mismo tiempo.',
      empty_state: {
        title: 'Segmenta formularios y tareas por grupos de usuarios',
        subtitle: '¿Qué es un grupo de usuarios?',
        descriptionPart1:
          'Los grupos de usuarios permiten controlar qué información ve cada persona. Al asignar formularios a un grupo, solo sus miembros podrán acceder a esos formularios y a sus datos.',
        descriptionPart2:
          'Esto asegura que cada usuario vea únicamente lo que le corresponde según su rol o área, mejorando el control y la seguridad de la información.',
        block1: {
          title: '¿Por qué usar grupos de usuarios?',
          card1: {
            title: 'Control y seguridad de la información',
            description:
              'Agrupa usuarios con permisos y accesos especiales. Protege datos sensibles y asegura la confidencialidad.',
          },
          card2: {
            title: 'Gestión de equipos simplificada',
            description:
              'Asigna permisos por grupo para administrar equipos fácilmente. Ahorra tiempo y evita errores manuales.',
          },
          card3: {
            title: 'Optimiza la experiencia del equipo',
            description:
              'Muestra solo la información relevante para cada usuario. Agiliza procesos y mejora el trabajo en terreno.',
          },
        },
        block2: {
          title: 'Crea tu primer grupo de usuarios',
          demo1: {
            title: 'A través de DataScope',
            description:
              'Crea un grupo de usuarios directamente desde DataScope seleccionando manualmente los usuarios y formularios asociados.',
          },
          demo2: {
            title: 'Importando tu lista de usuarios',
            description:
              'Descarga la plantilla Excel desde DataScope, completa los datos de tus usuarios y súbela nuevamente a la plataforma. ¡Importante! No modifiques los encabezados y respeta el formato para garantizar una carga exitosa.',
          },
          next: 'Siguiente',
          previous: 'Anterior',
        },
        block3: {
          title: 'Agrupa, asigna y simplifica',
          description:
            'Ahora que conoces cómo funcionan los grupos, crea uno, empieza a usarlos en tus tareas diarias y empieza a optimizar tus operaciones',
        },
      },
    },
    setProfile: {
      completeProfile: 'Completa tu perfil',
      completeProfileDescription:
        'Por favor, ingresa los siguientes datos para ingresar a DataScope',
      newPassword: 'Nueva contraseña',
      name: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      save: 'Guardar',
      updateSuccess: 'Perfil actualizado con éxito',
      updateError: 'Ocurrió un error al actualizar el perfil',
      identifier: 'Identificador',
    },
    importUsers: {
      invalidFileType: 'Tipo de archivo inválido. Por favor, sube un archivo .xlsx',
      dragDropHere: 'Arrastra y suelta tu archivo Excel aquí',
      orBrowse: 'o navega',
      downloadSuccess: 'Modelo descargado con éxito!',
      downloadError: 'No se pudo descargar el modelo',
      uploadSuccess: 'Archivo subido con éxito!',
      uploadError: 'No se pudo subir el archivo',
      importTitle: 'Importar Usuarios',
      upload: 'Importar',
      downloadStep: 'Paso 1: Descarga el archivo modelo',
      downloadStepHelper: 'Descarga el archivo modelo para completar la información del usuario',
      editStep: 'Paso 2: Edita el archivo',
      editStepHelper: 'Edita el archivo Excel y completa los campos requeridos *.',
      uploadStep: 'Paso 3: Sube el archivo',
      uploadStepHelper: 'Sube el archivo editado para importar usuarios.',
      downloadTemplate: 'Descargar Ejemplo',
      afterUploadInfo:
        'Después de subir, los usuarios serán procesados y se te notificará si hay errores.',
      replace: 'Reemplazar',
      fileLoadedMessage: 'Tu archivo ha sido cargado',
    },
  },
  login: {
    greeting: '¡Hola de nuevo!',
    loginHelper: 'Para continuar, ingresa tus credenciales',
    googleLogin: 'Inicia sesión con Google',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    login: 'Iniciar sesión',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate aquí',
    success: 'Inicio de sesión exitoso',
    error: 'Error al iniciar sesión',
    wrongCredentials: 'Email o contraseña incorrectos. Verifica tus datos e intenta nuevamente.',
    logoutError: 'Error al cerrar sesión',
    recaptchaError: 'Verificación de captcha falló. Por favor, intenta nuevamente.',
    mfaTitle: 'Autenticación de dos factores',
    mfaSubtitle: 'Ingresa el código de 6 dígitos de tu aplicación de autenticación',
    mfaCodeLabel: 'Código de verificación',
    verify: 'Verificar',
    backToLogin: '← Volver al inicio de sesión',
    invalidMfaCode: 'Por favor, ingresa un código válido de 6 dígitos',
    invalidMfaCodeError: 'Código de verificación inválido. Por favor, intenta nuevamente.',
    mfaStatusError: 'Error al consultar el estado de 2FA',
    mfaEnableError: 'Error al habilitar MFA',
    mfaEnabledSuccess: 'MFA habilitado correctamente',
    mfaVerifyError: 'Error al verificar MFA',
    mfaDisableError: 'Error al deshabilitar MFA',
    mfaDisabledSuccess: 'MFA deshabilitado correctamente',
    mfaSetupTitle: 'Configura tu app autenticadora',
    mfaScanQr: 'Escanea el código QR con tu app autenticadora.',
    mfaSecretCode: 'Código secreto',
    mfaCancel: 'Cancelar',
    mfaClose: 'Cerrar',
    mfaSetup: 'Configurar MFA',
    mfaDisable: 'Deshabilitar MFA',
    ssoLogin: 'Inicio de sesión SSO',
    ssoSubtitle: 'Para continuar, ingresa tu correo electrónico corporativo',
    ssoCompanyEmail: 'Correo Corporativo',
    ssoCompanyEmailPlaceholder: 'Ingresa tu dirección de correo corporativo',
    ssoValidating: 'Validando tu correo...',
    ssoContinue: 'Continuar con SSO',
    ssoHelpText: 'Te redirigiremos a la página de inicio de sesión de tu empresa',
    ssoBackToLogin: 'Iniciar sesión con contraseña',
    ssoSignInWithSSO: 'Iniciar sesión con SSO',
    ssoCompletingAuth: 'Completando autenticación...',
    ssoVerifyingCredentials: 'Verificando tus credenciales',
    ssoAuthSuccessful: '¡Autenticación exitosa!',
    ssoAuthFailed: 'Autenticación fallida',
    ssoRedirecting: 'Redirigiendo...',
    ssoError: 'La autenticación SSO falló. Por favor, intenta nuevamente.',
    ssoTooManyAttempts: 'Demasiados intentos de inicio de sesión. Por favor, intenta más tarde.',
    ssoInvalidIdentifier:
      'Dirección de correo inválida. Por favor, verifica tu correo corporativo e intenta nuevamente.',
    ssoFailedValidation:
      'Falló la validación del correo. Por favor, verifica tu correo corporativo e intenta nuevamente.',
    ssoNoAccountsFound:
      'No se encontraron cuentas habilitadas para SSO para este dominio de correo.',
    ssoFailedStatus: 'Error al verificar el estado de SSO. Por favor, inténtalo de nuevo.',
    secureLoginMessage:
      'Estás iniciando sesión con tu cuenta corporativa a través de un inicio seguro.',
    ssoFailedInitiate: 'Error al iniciar el login SSO. Por favor, inténtalo de nuevo.',
    checkingAuthentication: 'Verificando autenticación...',
    ssoConnecting: 'Conectando con tu cuenta corporativa...',
    ssoRedirectingToSSO:
      'Te estamos redirigiendo al inicio de sesión seguro de tu empresa para completar el acceso.',
    ssoNoSSO: 'Esta cuenta no utiliza inicio de sesión único (SSO).',
    ssoContinueWith: 'Continuar con',
    ssoAuthenticationFailed: 'Autenticación fallida. Por favor, intenta nuevamente.',
    ssoAuthenticationError: 'Ocurrió un error al autenticar. Por favor, intenta nuevamente.',
    ssoAuthenticationProcessing: 'Procesando autenticación...',
    ssoAuthenticationFailedRedirect: 'Autenticación fallida. Redirigiendo a inicio de sesión...',
    ssoAuthenticationCompleting: 'Completando autenticación...',
    ssoFailedProviderLogin: 'Error al iniciar el login con el proveedor seleccionado.',
    ssoSelectProvider: 'Selecciona una opción para continuar',
  },
  forgotPassword: {
    title: 'Restablecer contraseña',
    description:
      'Ingresa tu correo y te enviaremos un enlace para que puedas cambiar tu contraseña.',
    email: 'Correo electrónico',
    continue: 'Continuar',
    backToLogin: 'Volver a inicio de sesión',
    success:
      'Si el correo ingresado es válido, te enviaremos un mensaje con los pasos. Si no lo ves, revisa tu bandeja de spam.',
    error: 'Ocurrió un error al enviar el correo, por favor intenta nuevamente.',
    recaptchaError: 'Verificación de captcha falló. Por favor, intenta nuevamente.',
  },
  resetPassword: {
    title: 'Cambiar contraseña',
    description: 'Escribe y confirma tu nueva contraseña.',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    continue: 'Reestablecer contraseña',
    passwordsMatchError: 'Las contraseñas no coinciden',
    success: 'Contraseña actualizada con éxito',
    error: 'Ocurrió un error al actualizar la contraseña, por favor intenta nuevamente.',
  },
  signUp: {
    title: 'Regístrate ahora',
    subtitle: 'Sin tarjeta de crédito, cancela en cualquier momento',
    name: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    password: 'Contraseña',
    companyName: 'Empresa',
    role: 'Cargo',
    phoneNumber: 'País y teléfono',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    signUp: 'Crear cuenta',
    error: 'Ocurrió un error al registrar el usuario, por favor intenta nuevamente.',
    privacyPolicyText: 'Haciendo click aseguras de que estás de acuerdo con nuestra',
    privacyPolicyLink: 'Política de privacidad',
    emailError: 'Correo electrónico inválido',
    phoneNumberError: 'Número de teléfono inválido',
    passwordError: 'La contraseña debe tener al menos 6 caracteres',
  },
  templates: {
    total_templates: 'Total plantillas: ',
    see_all: 'Ver todas',
    showing_results: 'Mostrando resultados de',
    categories: 'Categorías',
    in: 'en',
    useTemplate: 'Usar plantilla',
    loginToAnswerTemplate: 'Podrás responder esta plantilla después de ingresar a tu cuenta',
    backToDataScope: 'Volver a DataScope',
    noResults: '¡No hemos encontrado lo que buscas, pero nos encantaría encontrar la solución!',
    contactSupport: 'Cuéntanos qué formulario necesitas via chat',
    next: 'Siguiente',
    back: 'Atrás',
    useCase: 'Puede ser usado para:',
    createdBy: 'Creado por',
    anonymousUser: 'Usuario anónimo',
    preview: 'Vista previa',
    editableTemplate: 'Esta plantilla es editable una vez que se importa.',
    allTemplates: 'Plantillas',
    noDescription: 'Sin descripción',
    bannerSlogan: 'Transforma tus operaciones con tecnología móvil',
    templateView: 'Vista plantilla',
    seeLess: 'Ver menos',
    seeMore: 'Ver más',
    importError: {
      formLimitReached:
        'Límite de formularios alcanzado. Por favor actualiza tu plan para importar más formularios.',
      alreadyImported: 'Este formulario ya ha sido importado.',
      validationError: 'Error de validación al importar la plantilla.',
      loginRequired: 'Debes iniciar sesión para importar plantillas.',
      genericError: 'Ocurrió un error al importar la plantilla. Por favor intenta nuevamente.',
      invalidUrl: 'URL de plantilla inválida. Por favor verifica el enlace e intenta nuevamente.',
    },
  },
  navbar: {
    features: 'Funcionalidades',
    solutions: 'Soluciones',
    work_orders: 'Órdenes de Trabajo',
    safety: 'Seguridad y Salud en el Trabajo',
    inspections: 'Inspecciones',
    quality: 'Controles de Calidad',
    resources: 'Recursos',
    blog: 'Blog',
    ds_academy: 'Academia DataScope',
    digitize: 'Sube tu formulario',
    roi: 'Calculadora de Ahorro',
    pricing: 'Precios',
    sales: 'Contáctanos',
    wapp: 'Hablemos por WhatsApp',
    call: 'Agenda un llamado',
    demo: 'Solicita una demo',
    sign_in: 'Iniciar Sesión',
    sign_up: 'Prueba Gratis',
    log_out: 'Cerrar Sesión',
    paths: {
      work_orders: 'ordenes-trabajo',
      safety: 'seguridad',
      inspections: 'inspecciones',
      quality: 'calidad',
      blog: 'blog',
      ds_academy: 'como-usar-datascope',
      digitize: 'sube-tu-formulario',
      roi: 'roi-chile',
    },
  },
  uiComponents: {
    search: 'Buscar',
    showingResultsFor: 'Mostrando resultados de búsqueda para',
    found: 'encontrados',
    cancel: 'Cancelar',
    selected: 'seleccionados',
    confirm: 'Confirmar',
    close: 'Cerrar',
    chooseMethodDialog: {
      fromDatascope: 'Desde DataScope',
      importExcel: 'Importar Excel',
    },
    signature: {
      title: 'Firma electrónica',
      alert:
        'Completa la siguiente información para activar la firma electrónica. El nombre y apellido en el área de información son necesarios para crear tu firma.',
      accountAlert: ' Recuerda hacer clic en "Guardar firma".',
      saveSignature: 'Guardar firma',
      completeSignatureWarning:
        'Debes completar todos los campos obligatorios para poder guardar tu firma',
      signatureRequiredFieldError: 'Este campo es obligatorio para crear la firma electrónica',
      updateSuccess: 'Firma actualizada con éxito',
      updateError: 'Ocurrió un error al actualizar la firma',
      invalidEmailError: 'Correo electrónico inválido',
      emailExistsError: 'El correo electrónico se encuentra en uso',
      validatingRut: 'Validando RUT...',
      emailErrors: {
        REGEX_INVALID: 'Correo electrónico inválido',
        IN_USE: 'El correo electrónico se encuentra en uso',
      },
    },
  },
  accountConfig: {
    information: {
      title: 'Configuración de cuenta',
      name: 'Nombre empresa',
      description: 'Descripción empresa',
      email: 'Email empresa',
      phone: 'Teléfono empresa',
      address: 'Dirección empresa',
      timezone: 'Zona horaria',
      locale: 'Idioma',
      logo: 'Logo',
      uploadLogo: 'Imagen',
      logoDescription:
        'La imagen debe estar en formato .PNG o .JPG y el tamaño debe ser 400x400 px con un peso no mayor a 2MB.',
      logoSizeError: 'El máximo tamaño de imagen permitido es de 2MB',
      saveSuccess: 'Configuración actualizada con éxito',
      saveError: 'Ocurrió un error al actualizar la configuración',
      pdfAlert: 'La información aquí configurada aparecerá en el encabezado del PDF estándar.',
      confirmDeleteLogo: '¿Estás seguro que quieres eliminar el logo?',
    },
    advancedConfig: {
      title: 'Configuración avanzada',
      activateSupportUser: 'Otorgar acceso al usuario de soporte DataScope',
      securityConfig: 'Configuración de seguridad',
      deactivateAccount: 'Deshabilitar cuenta',
      confirmTitle: '¿Estás seguro que deseas desactivar tu cuenta?',
      confirmMessage:
        'Esta acción es irreversible. También se desactivarán todos los usuarios y datos asociados a esta cuenta.',
    },
    mfaConfig: {
      title: 'Seguridad de la cuenta (2FA)',
      subtitle:
        'Protege tu cuenta con un nivel adicional de seguridad.\nAl activarlo, se solicitará un código temporal desde una app autenticadora (como Google Authenticator o Authy) al iniciar sesión.',
      activateMfa: 'Activar autenticación en dos pasos',
      configMode: '¿Cómo quieres configurarla a los usuarios de tu cuenta?',
      optional: 'Opcional',
      mandatory: 'Obligatoria',
      optionalDescription: 'Cada usuario podrá activarla desde su configuración de usuario',
      mandatoryDescription: 'Todos los miembros deberán configurarla para acceder a la plataforma',
    },
  },
  notifications: {
    title: 'Notificaciones',
    searchPlaceholder: 'Buscar por nombre formulario...',
    viewFormAnswer: 'Ver respuesta',
    viewExcel: 'Ver Excel',
    viewPdf: 'Ver PDF',
    tableHeaders: {
      date: 'Fecha',
      type: 'Tipo',
      form: 'Formulario',
      formCode: 'Código',
      user: 'Usuario',
      location: 'Lugar',
      actions: 'Acciones',
    },
    formExport: 'Exportación de formulario',
    formAnswer: 'Respuesta de formulario',
    filters: {
      title: 'Filtros',
      filterByType: 'Por tipo',
      filterByLocation: 'Por lugar',
      filterByUser: 'Por usuario',
      filterByDateRange: 'Por rango de fecha',
      startDate: 'Inicio',
      endDate: 'Fin',
      invalidDate: 'Fecha inválida',
      invalidDateRange: 'Rango de fechas inválido',
      to: 'hasta',
      eraseAll: 'Borrar todo',
      apply: 'Aplicar',
      formAnswers: 'Respuestas',
      formExports: 'Exportaciones',
      clear: 'Borrar',
      locationPlaceholder: 'Selecciona un lugar',
      userPlaceholder: 'Selecciona un usuario',
      showingResultsFor: 'Mostrando resultados de búsqueda para',
    },
    noNotifications: 'No tienes notificaciones en este momento',
    noResults: 'No se encontraron notificaciones relacionadas con los filtros aplicados',
    limitReached:
      'Su cuenta alcanzó el límite, debes activar la cuenta para habilitar nuevamente las funcionalidades.',
  },
  formEmailBuilder: {
    message: 'Mensaje',
    subject: 'Asunto',
    senderName: 'Nombre remitente del correo',
    addFooter: 'Agregar Firma',
    footerTitle: 'Firma',
    notification: 'Notificación',
    autoNotify: 'Notificar a los correos fijos',
    save: 'Guardar',
    cancel: 'Cancelar',
    linkName: 'Link descarga PDF formulario',
    linkNamePlaceholder: 'Escribe el nombre que quieres que tenga link',
    linkNameHelp: 'El nombre que configures será el del link de descarga que llegará al correo.',
    saveSuccess: 'Configuraciones guardadas con éxitos',
    saveError: 'Ocurrió un error al guardar las configuraciones',
    autoGeneratePdf: 'Generar PDF automáticamente',
  },
  formSignatureBuilder: {
    signatureTitle: 'Activación Firma',
    checkboxSignatureActivate: 'Activar firma electrónica',
    settingsTitle: 'Configuración general',
    save: 'Guardar',
    cancel: 'Cancelar',
    saveSuccess: 'Configuración guardada con éxito',
    saveError: 'Ocurrió un error al guardar la configuración',
    saveErrorReload:
      'Ocurrió un error al guardar la configuración. Por favor, recargue la página e intente nuevamente',
    accountSignatureConfigError: 'Falta configurar la firma electrónica de la cuenta',
    generalSettings: 'Configuración general',
    mandatorySignature:
      'Firma obligatoria (Todos los usuarios configurados deben responder a la solicitud, ya sea firmando o rechazándola)',
    optionalSignature: 'Firma opcional (Uno de los firmantes configurados debe firmar)',
    signersSettings: 'Configuración firmantes',
    authorMustSign: 'El usuario que envíe una respuesta también debe firmar',
    fixedSignerTitle: 'Firmante fijo',
    changeSelection: 'Cambiar selección',
    dynamicSignerTooltip:
      'Los firmantes dinámicos están disponibles en el plan Enterprise. Actualiza tu plan y accede a esta y más funciones avanzadas.',
    upgradePlan: 'Actualiza tu plan',
    assignOwner: 'Asignar responsable',
    searchPlaceholder: 'Buscar usuario o grupo',
    usersTab: 'Usuarios',
    groupsTab: 'Grupos',
    addButton: 'Agregar',
    cancelButton: 'Cancelar',
    externalUsers: 'Usuarios externos',
    externalUsersDescription: 'Los usuarios externos podrán ver y firmar el formulario',
    selectResponsible: 'Selecciona el responsable de la solicitud',
    addResponsible: 'Agregar responsable',
    selectUsersToSign: 'Selecciona los usuarios que deben firmar el documento',
    selectResponsibleTooltip:
      'El usuario seleccionado podrá seguir el estado de todas las solicitudes y editarlas, pero no podrá firmar. Para que firme, debe añadirse a la lista de firmantes',
    simultaneousSign: 'Firma Simultánea',
    sequentialSign: 'Secuencia de firmas',
    simultaneousSignInfo: 'La solicitud se enviará al mismo tiempo a todos los usuarios',
    sequentialSignInfo: 'La solicitud se enviará en el orden que establezcas',
    simultaneousEmptyState: 'Arrastra aquí los usuarios para sacarlos de la secuencia',
    sequentialEmptyState: 'Arrastra aquí los usuarios para crear una secuencia de firmas',
    sequentialWarningInfo:
      'Debes agregar todos los usuarios para generar una solicitud - {value} usuarios',
    sequentialSignSuccess: 'Secuencia completa',
    automatedSignature: 'Activar solicitud de firma automática',
    locationUser: 'Mails de lugares',
    locationUserTooltip:
      'Al seleccionar "Conexión a lugares", la solicitud se enviará a todos los correos registrados en el primer lugar asociado.',
    locationUserViewEmails: 'Ver mails',
    locationConnection: 'Conexión a lugares',
    locationConnectionTooltip1:
      'Si el formulario incluye una pregunta para seleccionar un lugar, se enviará una solicitud a los mails allí configurados',
    locationConnectionTooltip2:
      'Si asignas una tarea con este formulario y eliges un lugar, los mails allí configurados recibirán una solicitud al completarse la tarea',
    optionalSignatureOrderDisabled:
      'Esta opción no esta disponible para la configuración de firma opcional',
    author: 'Autor de la respuesta',
    authorMustSignFirst:
      'Esta posición es fija dentro de la secuencia, pero puedes moverla a Firma Simultánea',
    deleteSigner: 'Eliminar usuario',
    unGroupSigner: 'Desagrupar',
    authorUserTooltip:
      'Si el autor de la respuesta ya forma parte de la secuencia, se mantendrá su posición original en lugar de la asignada para el autor',
    addSigners: 'Agregar firmantes',
    addSignersTitle: 'Agregar firmantes',
    selectConfigurationType:
      'Selecciona el tipo de configuración que necesitas. Puedes elegir uno o ambos.',
    fixedSigner: 'Firmante fijo',
    fixedSignerDescription: 'Usuarios internos o externos',
    dynamicSignerCardDescription: 'Basado en respuestas del formulario',
    dynamicSigner: 'Firmante dinámico',
    dynamicSignerDescription:
      'Los firmantes dinámicos se definen a partir de respuestas en preguntas tipo',
    dynamicSignerDescriptionBold:
      'Selección lista de datos con listas de lugares o personalizadas, o tipo Texto con validación de correo.',
    formQuestionsTitle: 'Preguntas de este formulario',
    noDynamicSignatureQuestionsAvailable: 'No tienes preguntas de este tipo\nen este momento',
    selectedSignerSingular: 'seleccionado',
    selectedSignersPlural: 'seleccionados',
  },
  pricing: {
    title: '¡Descubre el plan perfecto para ti!',
    basic: {
      title: 'Básico',
      subtitle: 'Perfecto para explorar las funcionalidades de DataScope',
      features: [
        'Usuarios ilimitados',
        '60 respuestas de formulario/mes',
        'Datos almacenados por 30 días',
        'Constructor de formularios básico',
        'Asignador de tareas',
        'Dashboard estándar',
        'Resolución de fotografías estándar',
        'Funcionamiento sin internet',
      ],
      buttonText: 'Plan actual',
    },
    standard: {
      title: 'Estándar',
      subtitle:
        'Ideal para equipos que están dando sus primeros pasos en la digitalización de procesos',
      features: [
        'Todo lo incluido en el Plan Básico +',
        'Respuestas ilimitadas de formularios',
        'Datos almacenados por siempre',
        'Constructor de formularios avanzado',
        'Generador de informes PDF personalizados',
        'Permisos de usuarios editables',
        'Integración de datos con otras plataformas',
        'Chat entre usuarios en la App',
        'Soporte email / teléfono / chat',
      ],
    },
    premium: {
      title: 'Premium',
      subtitle:
        'Para empresas que requieren una visión integral y en tiempo real de todas sus operaciones',
      features: [
        'Todo lo incluido en el Plan Estándar +',
        'Dashboards avanzados',
        'Soporte API',
        'Resolución de fotografías configurable',
        'Ejecutivo de cuentas asignado',
        'Soporte en flujos de trabajo',
      ],
      buttonText: 'Cambiar a Premium',
    },
    enterprise: {
      title: 'Enterprise',
      subtitle: 'Para grandes empresas que buscan una solución y soporte personalizado',
      features: [
        'Todo lo incluido en el Plan Premium +',
        'Implementación personalizada',
        'Soporte preferencial 24/7',
      ],
      buttonText: 'Hablar con ventas',
    },
    features: 'Funcionalidades',
    currentPlan: 'Plan actual',
    start: 'Empezar',
    mostPopular: 'Más popular',
    free: 'Gratis',
    monthlyPerUser: 'mensual por usuario',
    users: 'usuarios',
    standardBold: 'estándar',
    off: 'off',
    finishesIn: 'Termina en',
    ofDiscount: 'de descuento.',
    days: 'Días',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    salesLink: 'https://meetings.hubspot.com/andres-rivera4',
    activePayment: {
      demoSubscription: 'Suscripción pagada',
      demoSubscriptionDescription: 'Tu plan actual incluye ',
      demoSubscriptionDescription1: ' usuario(s).',
      demoSubscriptionDescription2: 'Puedes invitar más dando clic en el botón.',
      inviteUsers: 'Invitar usuarios',
      demoBannerDescription: '¡No tienes pagos pendientes!',
      demoBannerDescription2:
        'Si tienes alguna pregunta sobre tu suscripción, no dudes en ponerte en contacto con nuestro equipo.',
      moreInfo: 'Más información',
      viewBillingDetails: 'Ver detalles de facturación',
      changeUsers: 'Cambiar número de usuarios',
      modify: 'Modificar',
      monthlyValue: 'Valor mensual',
      annualValue: 'Valor anual',
      total: 'Total',
      valuesMayDiffer: '*Valores pueden cambiar en base a su moneda local.',
      modifyUsersSuccess: 'Suscripción actualizada con éxito',
      modifyUsersError:
        'Ocurrió un error al actualizar la suscripción, por favor intente nuevamente o comuníquese con soporte.',
      confirmModifyUsers: '¿Estás seguro que quieres cambiar el número de usuarios?',
      confirmModifyUsersDescription:
        'Si cambias el número de usuarios, el valor de tu suscripción cambiará en consecuencia y se cobrará la diferencia si corresponde.',
      numberOfUsers: 'Número de usuarios',
      paymentDetails: 'Detalles de pago',
    },
  },
  findings: {
    title: '{{finding_label_cap}}s',
    new: 'Nuevos',
    all: 'Todos',
    createdBy: 'Creado por',
    expires: 'Vence',
    type: 'Tipo',
    description: 'Descripción',
    searchPlaceholder: 'Buscar por nombre, descripción, autor o ID',
    createdIn: 'Creado en',
    originQuestion: 'Pregunta',
    note: 'Nota',
    viewForm: 'Ver formulario',
    createYourFirstFinding: 'Crea tu primer {{finding_label}}',
    emptyState:
      'Agrega una pregunta de tipo Checklist a un formulario nuevo o existente para comenzar a crear {{finding_label}}s',
    goToForms: 'Ir a formularios',
    detailEmptyState: 'Selecciona un {{finding_label}} para ver el historial',
    findingDetail: 'Detalle del {{finding_label}}',
    idCopied: 'ID copiado!',
    delete: 'Eliminar',
    deletedSuccessfully: '{{finding_label_cap}} eliminado exitosamente',
    tabs: {
      inProgress: 'En progreso',
      closed: 'Cerrados',
    },
    options: {
      viewDetails: 'Ver detalle',
      addImage: 'Enviar imagen',
      sendFormAnswers: {
        menu: 'Enviar respuesta formulario',
        title: 'Respuesta formulario',
        button: 'Enviar a {{finding_label}}',
        cancel: 'Cancelar',
        description: 'Selecciona la respuesta que deseas enviar al {{finding_label}}',
        searchPlaceholder: 'Buscar formulario',
        answeredBy: 'Respondido por',
        updatedAt: 'Actualizado en',
        noResults: 'No se encontraron respuestas',
        seeAnswer: 'Ver respuesta',
        noAnswers: 'No tienes respuestas en este momento',
      },
      sendForms: {
        button: 'Enviar',
        menu: 'Enviar formulario',
        sync: 'Sincronizando',
      },
      share: {
        menu: 'Compartir enlace',
        title: 'Compartir enlace',
        text: 'Cualquier persona con el link puede acceder al {{finding_label}}',
        activate: 'Habilitar',
        deactivate: 'Deshabilitar',
        loginTitle: '¡Bienvenido a DataScope!',
        loginDescription: 'Para continuar, por favor ingresa tu nombre y correo electrónico',
        loginNamePlaceholder: 'Tu nombre',
        loginEmailPlaceholder: 'Correo electrónico',
      },
    },
    createFinding: {
      title: 'Crear {{finding_label}}',
      requiredInformation: 'Información requerida',
      optionalInformation: 'Información opcional',
      cancel: 'Cancelar',
      create: 'Crear',
      name: 'Nombre',
      type: 'Tipo de {{finding_label_cap}}',
      description: 'Descripción',
      assignees: 'Responsable(s)',
      dueDate: 'Vencimiento',
      location: 'Lugar',
      inviteParticipants: 'Invitar participantes',
      findingSuccess: '{{finding_label_cap}} creado exitosamente',
      findingError: 'Error al crear {{finding_label}}',
      findingCreated: '{{finding_label_cap}} creado',
      editInFindings:
        "Dirígete a la sección de '{{finding_label_cap}}s' para realizar algún cambio",
    },
    editFinding: {
      title: 'Editar {{finding_label}}',
      update: 'Actualizar',
      findingSuccess: '{{finding_label_cap}} actualizado exitosamente',
      findingError: 'Error al actualizar {{finding_label}}',
    },
    closeFinding: {
      title: 'Cerrar {{finding_label}}',
      instruction: 'Completa la siguiente información para cerrar el {{finding_label}}',
      closingNoteLabel: '¿En qué estado cerró el {{finding_label}}?',
      cancel: 'Cancelar',
      confirm: 'Cerrar {{finding_label}}',
    },
    status: {
      title: 'Estado',
      open: 'Abierto',
      in_progress: 'En curso',
      paused: 'Detenido',
      closed: 'Cerrado',
    },
    priority: {
      title: 'Prioridad',
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      critical: 'Crítica',
    },
    deleteWarningConfirm: '¿Estás seguro que quieres eliminar este {{finding_label}}?',
    deleteWarningConfirmDescription:
      'Se eliminará permanentemente y no podrás recuperarlo después.',
    chat: {
      events: {
        finding_created: '{{finding_label_cap}} creado',
        finding_closed: 'finalizó el {{finding_label}}',
        finding_closed_expired:
          'finalizó el {{finding_label}} después de la fecha de vencimiento estipulada',
        status: 'actualizó el estado a',
        priority: 'actualizó la prioridad a',
        description: 'actualizó la descripción del {{finding_label}} a',
        expiration_date: 'actualizó la fecha de vencimiento a',
        name: 'actualizó el nombre del {{finding_label}} a',
        location: 'actualizó el lugar del {{finding_label}} a',
        added_assignees: 'agregó a',
        removed_assignees: 'eliminó a',
        assignees_singular: 'como responsable',
        assignees_plural: 'como responsables',
        added_invitees: 'agregó a',
        removed_invitees: 'eliminó a',
        invitees_singular: 'como participante',
        invitees_plural: 'como participantes',
        no_expiration_date: 'sin fecha de vencimiento',
      },
      image: {
        error: 'Error',
        sync: 'Sincronizando Imagen',
      },
    },
    export: {
      pdf: {
        title: 'Exportar PDF',
        tooltip: 'Exportar PDF',
        info: 'Exportarás toda la información incluida en el {{finding_label}}. Una vez lo exportes, el link de descarga te llegará al mail.',
        exportSuccess: 'PDF de {{finding_label_cap}} exportado exitosamente',
        exportError: 'Error al exportar PDF de {{finding_label_cap}}',
        buttonTitle: 'PDF',
      },
      all: {
        title: 'Exportar todo',
        tooltip: 'Exportar a Excel',
        info: 'Exportarás las siguientes variables en formato Excel: Nombre, descripción, responsables, participantes, vencimiento, prioridad y lugar. Una vez lo exportes, el link de descarga te llegará al mail.',
        exportSuccess: '{{finding_label_cap}}s exportados exitosamente',
        exportError: 'Error al exportar {{finding_label_cap}}s',
        buttonTitle: 'Excel',
      },
      emailInputLabel: 'Email',
      cancel: 'Cancelar',
      confirm: 'Exportar',
    },
    landing: {
      headerTitle:
        'Soluciona {{finding_label}}s encontrados de forma rápida, con trazabilidad de inicio a fin',
      infoTitle1:
        'Podrás notificar a las personas correctas para generar un flujo de trabajo ideal y tener un seguimiento de la solución del {{finding_label}}.',
      actionButton: 'Comenzar prueba gratuita',
      infoDemoTime: 'Prueba {{finding_label}}s durante 30 días gratis',
      infoDisclaimer:
        'Una vez finalice la prueba gratuita podrás seguir creando {{finding_label}}s, pero no podrás acceder a ellos',
      headerImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-gif-es.gif',
      headerTicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-gif-es-ticket.gif',
      featuresTitle: 'Todo lo que necesitas',
      feature1Description: 'Crea {{finding_label}}s de forma personalizada según su prioridad',
      feature2Description: 'Mantén un registro de actualizaciones del {{finding_label}}',
      feature3Description: 'Realiza inspecciones y enlaza un {{finding_label}} a esta',
      feature1Image:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature1-es.png',
      feature1TicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature1-es-ticket.png',
      feature2Image:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature2-es.png',
      feature2TicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature2-es-ticket.png',
      feature3Image:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature3-es.png',
      feature3TicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-feature3-es-ticket.png',
      footerImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-notification-es.png',
      footerTicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-notification-es-ticket.png',
      infoTitle2:
        'Asegúrate de no perder ningún detalle al seguir la evolución del {{finding_label}}',
      featuresMobileImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-features-responsive-es.png',
      featuresMobileTicketImage:
        'https://data-scope.s3.us-west-2.amazonaws.com/assets/findings/findings-landing-features-responsive-es-ticket.png',
    },
    demoExpired: {
      title: '¡Tu prueba gratuita ha terminado!',
      description:
        'Para acceder a tus datos, te invitamos a adquirir el módulo de {{finding_label_cap}}s. Puedes acceder a él dando clic en el botón',
      actionButton: 'Activar {{finding_label_cap}}s',
    },
    suscriptionCancelled: {
      title: 'Tu suscripción ha expirado',
      description:
        'Para acceder a tus datos, te invitamos a pagar tu suscripción al módulo de {{finding_label_cap}}s',
    },
    adminAlert:
      'Podrás ver todos los {{finding_label}}s, pero para recibir actualizaciones debes asignarte como responsable o invitado.',
    configure: 'Configurar',
    config: {
      findingTypes: 'Tipos de {{finding_label}}s',
      createType: 'Crear tipo',
      editType: 'Editar',
      deleteType: 'Eliminar',
      deleteTypeDisabled: 'No puedes quedarte sin tipos de {{finding_label}}s',
    },
    integrations: {
      title: 'Integracion {{finding_label_cap}}s',
      button: 'Integraciones',
      gsheetsMenuName: 'Google Sheets',
      gsheetsIntegrationLabel: 'Ir a Google Sheets',
      infoTextPart1:
        'Para garantizar una integración adecuada, privada y segura, comparte tu documento con permisos de',
      infoTextPart2: 'editor',
      infoTextPart3: 'únicamente a',
      inputLabel: 'Nuevo Enlace',
      inputPlaceholder: 'Ingresa el enlace del documento a integrar',
      save: 'Guardar',
      cancel: 'Cancelar',
      copyUrl: '¡URL copiada!',
      created:
        '¡Integración configurada exitosamente! Por favor, espera unos segundos para que se reflejen los cambios',
      saved: '¡Cambios guardados con éxito!',
      savingError: 'Error al configurar la integración',
      confirmation: '¿Quieres guardar los cambios realizados antes de salir?',
      webhooks: 'Webhooks',
      webhookUrl: 'Webhook URL',
      infoWebhooksTextPart1:
        'Automatiza tus flujos de trabajo permitiendo que DataScope active procesos en plataformas externas.',
      infoWebhooksTextPart2: 'Mantén todo sincronizado sin esfuerzo.',
      import: 'Importar',
      populateGSheet: 'Poblar GSheet',
      populatingGSheet: 'Poblando GSheet...',
      populateGSheetSuccess: 'Google Sheet poblado exitosamente',
      populateGSheetError: 'Error al poblar el Google Sheet',
    },
    findingTypes: {
      noType: 'Otro',
      createTitle: 'Crear Tipo de {{finding_label_cap}}',
      editTitle: 'Editar Tipo de {{finding_label_cap}}',
      name: 'Nombre',
      assignees: 'Responsable (Asignar a)',
      assigneesCaption: 'Si no asignas responsable, en la app lo podrás hacer',
      location: 'Lugar',
      locationCaption: 'Si no asignas un lugar, en la app lo podrás hacer',
      save: 'Guardar',
      update: 'Actualizar',
      cancel: 'Cancelar',
      dueDateAndPriority: 'Vencimiento y Prioridad',
      priorityInformationBanner:
        'Puedes seleccionar una prioridad como predeterminada (opcional). El creador del {{finding_label}} no podrá cambiarla, pero verá su descripción.',
      dueDate: 'Vencimiento',
      dueDateCaption:
        'Esta configuración empezará a contar desde la creación del {{finding_label}}',
      dueDateTypes: {
        days: 'Días',
        hours: 'Horas',
      },
      priority: 'Prioridad',
      description: 'Descripción',
      descriptionPlaceholder: 'Escribe la descripción o instrucción de la prioridad',
      additionalInformation: 'Información Adicional (Opcional)',
      additionalInformationBanner:
        'Asignar formularios pre determinados para que respondan las personas que participarán en el {{finding_label}}',
      typeCreatedSuccess: 'Tipo de {{finding_label}} creado con éxito',
      typeCreatedError: 'Error al crear tipo de {{finding_label}}',
      typeDeletedSuccess: 'Tipo de {{finding_label}} eliminado con éxito',
      typeDeletedError: 'Error al eliminar tipo de {{finding_label}}',
      typeUpdatedSuccess: 'Tipo de {{finding_label}} actualizado con éxito',
      typeUpdatedError: 'Error al actualizar tipo de {{finding_label}}',
      deleteTypeAlertTitle: '¿Estás seguro que quieres eliminar este tipo de {{finding_label}}?',
      deleteTypeAlertMessage:
        'Si lo eliminas ya no lo podrás recuperar, pero la información relacionada con este permanecerá en la plataforma',
    },
  },
  commonComponents: {
    formSelector: {
      title: 'Formularios',
      addForm: 'Agregar formulario',
      searchPlaceholder: 'Buscar formulario, carpeta...',
      forms: 'Formularios',
      folders: 'Carpetas',
      save: 'Guardar',
      cancel: 'Cancelar',
      see: 'Ver',
      more: 'más',
      close: 'Cerrar',
      maxFormsSelected: 'Máximo de formularios seleccionados',
    },
    confirmActionAlert: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    formDropdownSelector: {
      loading: 'Cargando...',
      noFormsFound: 'No se encontraron formularios',
    },
    dateRangePicker: {
      last7Days: 'Últimos 7 días',
      last14Days: 'Últimos 14 días',
      last30Days: 'Últimos 30 días',
      last60Days: 'Últimos 60 días',
      last90Days: 'Últimos 90 días',
      thisYear: 'Este año',
    },
    locationSelector: {
      loading: 'Cargando...',
      noLocationsFound: 'No se encontraron lugares',
      placeholder: 'Selecciona un lugar',
      nestableLocations: 'Lugares',
      legacyLocations: 'Lista de Lugares (Antiguo)',
    },
  },
  webHooks: {
    title: 'WebHooks',
    new: {
      title: 'Crear nuevo WebHook',
      token: 'Token:',
      expires_in: 'Expira en:',
      expires_at: 'Expira a las:',
      form: 'Formulario',
      select_form: 'Seleccionar un formulario',
      select_all_forms: 'Todos los formularios',
      url: 'Url de la conexión',
      example_url: 'http://www.tuservidor.com/servicio',
      send_modifications: 'Enviar modificaciones',
      oauth_checkbox: 'Autenticar con OAuth2',
      save: 'Guardar',
      back: 'Volver a WebHooks',
      configure_oauth: 'Configurar OAuth 2.0',
      access_token: 'URL del Token de Acceso',
      client_id: 'ID del cliente',
      client_secret: 'Llave secreta del cliente',
      scope: 'Scope',
      save_oauth: 'Guardar Configuración OAuth',
      save_oauth_success: 'Token de OAuth creado con éxito',
      save_oauth_error: 'Hubo un error al crear el token de OAuth',
      token_details: 'Detalles del Token',
      create_webhook: 'Crear WebHook',
      create_webhook_success: 'WebHook creado con éxito',
      create_webhook_error: 'Hubo un error al crear el WebHook',
    },
    update: {
      update_webhook: 'Actualizar WebHook',
      update_webhook_success: 'WebHook actualizado con éxito',
      update_webhook_error: 'Hubo un error al actualizar el WebHook',
    },
  },
  answerView: {
    alreadyRejectedSignature: 'Rechazaste firmar este formulario',
    rejectConfirmationTitle: '¿Estás seguro que quieres rechazar la solicitud?',
    rejectConfirmationDescription: 'Una vez rechazado, no podrás volver a firmar este formulario.',
    reject: 'Rechazar',
    rejectSuccess: '¡Solicitud de firma rechazada!',
    rejectError: 'No se pudo rechazar la firma',
    location: 'Lugar',
    address: 'Dirección',
    assignee: 'Responsable',
    taskInformation: 'Información de la tarea asignada',
    description: 'Descripción',
    tasks: 'Tareas',
    answeredFromMobile: 'Enviado desde aplicación móvil',
    answeredFromWeb: 'Enviado desde la web',
    electronicallySignedBy: 'Firmado electrónicamente por:',
    verifySignatureAlert:
      'Para firmar el formulario primero debes verificar tu firma, esto solo lo harás una vez.',
    configureSignatureAlert:
      'Para firmar el formulario primero debes configurar y verificar tu firma, esto solo lo harás una vez.',
    configureSignature: 'Configurar firma electrónica',
    lackOfPermissions:
      'No tienes permisos para editar tu perfil. Solicita al administrador que complete tu información para que puedas continuar.',
    verifySignature: 'Verificar firma',
    sign: 'Firmar',
    alreadySignedAlert: 'Ya firmaste este formulario',
    rejectedAlert: 'Rechazaste firmar este formulario',
    goToSignatures: 'Ir a firmas',
    signatureConfigAlert: 'Por favor revisa la configuración de firma electrónica',
    signSuccess: '¡Formulario firmado exitosamente!',
    signError: 'Ocurrió un error al firmar el formulario',
    signatureVerifySuccess:
      '¡Verificaste tu firma electrónica exitosamente! Ahora podrás firmar todos tus formularios',
    signatureVerifyError: 'Ocurrió un error al verificar tu firma electrónica',
    checkedCountInfo: 'elementos seleccionados',
    checkedCountListInfo: 'Elementos seleccionados de una lista de',
    items: 'elementos',
    total: 'total',
    group: 'Grupo',
    attachedFiles: 'Estos son los archivos adjuntos a esta pregunta',
    editAnswer: 'Editar respuesta',
    editAnswerDisabled: 'No puedes editar la respuesta porque tiene una solicitud de firma',
    viewDocumentValidation: 'Ver Validación de Documento',
    qrUniqueDocumentTitle: 'QR único del documento',
    qrUniqueDocumentDescription:
      'Este documento incorpora firma electrónica, la autenticidad de este puede ser verificada escaneando el código QR',
    metadataComments: {
      item: 'Ítem',
      answer: 'Respuesta',
      description: 'Comentario',
      images: 'Imágenes',
      issues: '{{finding_label_cap}} creado',
      viewIssue: 'Ver {{finding_label}}',
    },
    expiredLink: {
      description: 'Este link ha vencido. Solicita uno nuevo dando click en el botón',
      button: 'Solicitar link',
      newLinkRequestedSuccess: 'El link ha sido enviado a tu correo',
      newLinkRequestedError: 'Ocurrió un error al solicitar el link',
    },
    externalUserSign: {
      title: 'Registra tu firma',
      registeredDescription:
        'Tu firma se encuentra registrada, por favor confirma tus datos para poder continuar',
      unregisteredDescription:
        'Tu información personal no se encuentra registrada, te invitamos a completar los siguientes datos',
      name: 'Nombre completo',
      company: 'Empresa',
      role: 'Cargo',
      confirm: 'Continuar',
      cancel: 'Cancelar',
      success: '¡Formulario firmado exitosamente!',
      error: 'Ocurrió un error al firmar el formulario',
    },
    locationInfo: {
      title: 'Información de ubicación detectada',
      description: 'La respuesta se detectó en una ubicación de tu lista de lugares',
      viewInMap: 'Ver en mapa',
      nameAndDistance: 'Nombre y distancia',
      distanceHelpIcon:
        'Muestra la distancia entre el lugar seleccionado en la respuesta y la ubicación registrada al responder',
      awayFromLocation: 'km de la ubicación',
    },
    signature: {
      name: 'Nombre',
      idNumber: {
        CL: 'RUT',
        PE: 'DNI',
        MX: 'CURP',
        CO: 'CC',
        AR: 'DNI',
        PY: 'CI',
        ES: 'DNI/NIE',
        BR: 'CPF',
        UY: 'CI',
        BO: 'CI',
        EC: 'Cédula',
        VE: 'Cédula',
        US: 'SSN',
        CA: 'SIN',
        DO: 'Cédula',
        CR: 'Cédula',
        PA: 'Cédula',
        GT: 'DPI',
        SV: 'DUI',
        HN: 'DNI',
        NI: 'Cédula',
        PR: 'SSN',
        CU: 'CI',
        JM: 'TRN',
        PT: 'NIF',
        FR: 'INSEE',
        DE: 'ID Tributario',
        IT: 'Codice Fiscale',
        GB: 'Número de Seguro Nacional',
        IE: 'Número PPS',
        NL: 'BSN',
        BE: 'Número Nacional',
        CH: 'Número AHV',
        AT: 'Número de Seguridad Social',
        SE: 'Número Personal',
        NO: 'ID Nacional',
        DK: 'Número CPR',
        FI: 'Código de Identidad Personal',
        IS: 'Kennitala',
        PL: 'PESEL',
        CZ: 'Número de Nacimiento',
        SK: 'Número de Nacimiento',
        HU: 'Número Tributario',
        RO: 'CNP',
        BG: 'EGN',
        GR: 'AMKA/AFM',
        HR: 'OIB',
        SI: 'EMSO',
        RS: 'JMBG',
        BA: 'JMBG',
        ME: 'JMBG',
        MK: 'EMBG',
        MT: 'Tarjeta de ID',
        CY: 'Número de ID',
        LU: 'ID Nacional',
        LT: 'Código Personal',
        LV: 'Código Personal',
        EE: 'Código Personal',
        TR: 'TC Kimlik No',
        IL: 'Número de ID',
        SA: 'ID Nacional',
        AE: 'Emirates ID',
        QA: 'QID',
        KW: 'ID Civil',
        BH: 'CPR',
        OM: 'ID Civil',
        JO: 'ID Nacional',
        LB: 'Número de ID',
        EG: 'ID Nacional',
        MA: 'CIN',
        TN: 'CIN',
        DZ: 'ID Nacional',
        ZA: 'Número de ID',
        NG: 'NIN',
        KE: 'Número de ID',
        GH: 'Ghana Card',
        UG: 'ID Nacional',
        TZ: 'NIDA',
        RW: 'ID Nacional',
        BW: 'Omang',
        NA: 'Número de ID',
        ZM: 'NRC',
        ZW: 'ID Nacional',
        ET: 'ID Nacional',
        CN: 'ID Nacional',
        IN: 'Aadhaar',
        PK: 'CNIC',
        BD: 'NID',
        JP: 'My Number',
        KR: 'RRN',
        SG: 'NRIC/FIN',
        MY: 'MyKad',
        ID: 'KTP',
        PH: 'UMID',
        TH: 'ID Nacional',
        VN: 'CCCD',
        HK: 'HKID',
        TW: 'ID Nacional',
        LK: 'NIC',
        NP: 'ID Nacional',
        AU: 'TFN/Medicare',
        NZ: 'Número IRD',
        RU: 'SNILS',
        UA: 'Número Tributario',
        BY: 'ID Nacional',
        KZ: 'IIN',
        UZ: 'PINFL',
        GE: 'Número Personal',
        AM: 'Tarjeta Social',
        AZ: 'FIN',
      },
      email: 'Email',
      date: 'Fecha',
      of: 'de',
      rejectedInfoPartial: 'rechazó este documento el',
      weInviteYouTo: 'Te invitamos a',
      makeCorrections:
        'hacer las correcciones necesarias en el documento actual y generar una nueva solicitud de firma.',
    },
    backToHome: 'Volver a inicio',
    paywall: {
      title: 'Has alcanzado el límite de respuestas. Actualiza tu plan para ver más',
      button: 'Actualizar plan',
      chat_message: 'Hola, necesito ver más respuestas. ¿Cómo puedo actualizar mi plan?',
    },
    downloadPdf: 'Descargar PDF',
    status: 'Estado',
    noStatus: 'Sin estado',
    activityPeriodTime: {
      startTime: 'Inicio de actividad',
      endTime: 'Fin de actividad',
      activity: 'Actividad',
      duration: 'Duración',
    },
  },
  electronic_signature: {
    verifySignature: 'Verificar firma',
    annex: 'Anexo',
    sendCode: 'Enviar código',
    errorSendingCode: 'Ha ocurrido un error enviando el código',
    successSendingCode: 'Código enviado correctamente',
    code_sent_to_email: 'Enviamos el código de verificación a tu correo:',
    resendCodeLabel: 'No recibiste el código? ',
    resend: 'Reenviar',
    incorrect_code: 'Código incorrecto, te quedan {remaining_attempts} intentos',
    maxAttemptsReached: 'Has alcanzado el máximo de intentos, se reenvió un nuevo código',
    errorVerifyingCode: 'Error al verificar el código',
    back: 'Volver',
    share: 'Compartir',
    signatures: {
      title: 'Mis firmas',
      signature_date: 'Fecha de firma',
      noPendingSignatures: '¡Felicitaciones! No tienes firmas pendientes en este momento',
      noCompletedSignatures: 'No tienes firmas completadas en este momento',
      selected: 'Seleccionados',
      sign: 'Firmar',
      viewAndDownload: 'Ver y descargar',
      massiveSignError: 'Ocurrió un error al firmar los formularios',
      massiveSignSuccess: 'Formularios firmados exitosamente',
      downloadError: 'Ocurrió un error al descargar el archivo',
    },
    documentValidation: {
      validDocumentTitle: 'Documento Válido',
      formSummary:
        'Formulario {form_name} respondido por {user_name}. Fecha respuesta: {answer_date}.',
      openDetails: 'Accede a los detalles del documento aquí',
      respondedByLabel: 'Respondido por:',
      answerDateLabel: 'Fecha respuesta:',
      signedByTitle: 'Firmado por:',
      signerNameLabel: 'Nombre',
      signerRutLabel: 'RUT',
      signerEmailLabel: 'Email',
      signerDateLabel: 'Fecha',
      accessRestrictionNote:
        'Para acceder a los detalles del documento debes estar registrado en DataScope',
      footerLegalText:
        'Este documento cumple con la normativa chilena vigente y su firma electrónica está validada por la Dirección del Trabajo.',
      footerOrdinanceIntro: 'Consulta la ordenanza ',
      footerOrdinanceLinkLabel: 'aquí',
      footerCta: 'Digitaliza tus documentos con DataScope',
      noSigners: 'Este documento aún no tiene firmas registradas',
      error: 'No pudimos validar este documento. Verifica el enlace o contacta a soporte.',
    },
    requests: {
      notifyByEmail: 'Notificar vía email',
      title: 'Solicitudes enviadas',
      mandatory: 'Firma obligatoria',
      optional: 'Firma opcional',
      ongoing: 'En curso',
      completed: 'Finalizadas',
      searchPlaceholder: 'Buscar por usuario o formulario...',
      form: 'Formulario',
      requestDate: 'Fecha solicitud',
      requestedBy: 'Solicitado por',
      goToSign: 'Ir a firmar',
      signatureDate: 'Fecha firma',
      signatures: 'Firmas',
      signed: 'Ya firmaron',
      pending: 'Pendientes',
      actions: 'Acciones',
      deleteRequest: 'Eliminar solicitud',
      deleteSuccess: 'Solicitud eliminada con éxito',
      deleteError: 'Ocurrió un error al eliminar la solicitud',
      notifyByEmailSuccess: 'Usuarios notificados exitosamente',
      notifyByEmailError: 'Ocurrió un error al notificar a los usuarios',
      noOngoingRequests: '¡Todo en orden! No tienes solicitudes en curso en este momento',
      noCompletedRequests: 'No tienes solicitudes finalizadas en este momento',
      shareModal: {
        title: 'Compartir solicitud de firma finalizada',
        share: 'Compartir',
        infoAlert:
          'Se enviará un archivo por correo electrónico. Los destinatarios podrán acceder a los detalles y revisarlos fácilmente.',
        emailInstruction: 'Ingresa la direccion a la que deseas enviar el archivo.',
        inputInstruction: 'Puedes agregar tareas rápidamente separándolas con comas ",".',
        cancel: 'Cancelar',
      },
      shareSuccess: 'Solicitud compartida exitosamente',
      shareError: 'Ocurrió un error al compartir la solicitud',
      deleteWarningTitle: '¿Estás seguro que quieres eliminar esta solicitud?',
      deleteWarningMessage:
        'Las firmas ya realizadas seguirán siendo válidas y quedarán guardadas en el historial.',
      timeline: {
        title: 'Detalle de solicitud',
        close: 'Cerrar',
        createdRequired: '{user} ha enviado una solicitud de firma obligatoria',
        createdOptional: '{user} ha enviado una solicitud de firma opcional',
        createdRequiredSimultaneous: '{user} ha enviado una solicitud de firma obligatoria a:',
        createdOptionalSimultaneous: '{user} ha enviado una solicitud de firma opcional a:',
        createdRequiredSequential:
          '{user} envió una solicitud de firma obligatoria con este orden:',
        createdOptionalSequential: '{user} envió una solicitud de firma opcional con este orden:',
        signed: '{user} firmó el documento',
        signedOrder: '{user} firmó el documento ({number} firmantes)',
        signedOrderGroup: '{user} firmó el documento ({number} firmantes del grupo {group})',
        rejected: '{user} rechazó la solicitud',
        signatureRequested: 'Solicitud enviada a {user} ({number} firmantes)',
        signatureRequestedGroupSingular: 'Solicitud enviada a {users} (Firmante grupo {group})',
        signatureRequestedGroupPlural: 'Solicitud enviada a {users} (Firmantes grupo {group})',
        completed: 'Todas las firmas requeridas fueron completadas. El documento ya está listo',
        signer: 'Firmante',
        group: 'Grupo',
      },
      tooltip: {
        signed: 'Solicitud finalizada',
        rejected: 'Solicitud rechazada',
      },
    },
    promo: {
      title: 'Firma reportes de forma digital y asegura procesos',
      description:
        'Con el módulo de Firmas podrás solicitar y firmar procesos de forma simple y segura.',
      actionButton: '¡Quiero implementar Firmas!',
      moreInfoTitle: '¡Garantiza la trazabilidad y reduce el margen de error!',
      infoPoint1: 'Solicita firmas a tu equipo en terreno y envía notificaciones automáticas',
      infoPoint2: 'Garantiza el cumplimiento de tus procesos',
      infoPoint3: 'Aprobado por la Dirección del Trabajo (válido solo en Chile)',
      infoPoint4: 'Accede a tus datos de forma segura desde cualquier dispositivo',
      moreInfoButton: '¡Quiero más información!',
      moreInfoLink: 'https://help.mydatascope.com/es/articles/8728763-firma-electronica-verificada',
    },
    emptyState: {
      mainBanner: {
        title: 'Firma reportes de forma digital y asegura procesos',
        description:
          'Con el módulo "Firmas" podrás solicitar y firmar procesos de forma simple y segura.',
        actionButton: '¡Quiero implementar Firmas!',
        actionButtonError:
          'Ocurrió un error al solicitar la implementación. Contáctese con soporte para más información.',
        actionButtonSuccess: 'Solicitud de implementación enviada exitosamente',
        actionButtonTooltipAdminUnrequested: 'Solicitar implementación',
        actionButtonTooltipAdminRequested: 'Ya se ha solicitado la implementación',
        actionButtonTooltipUser: 'Solo el administrador de la cuenta puede realizar esta acción',
      },
      gallery: {
        title: 'Gestiona firmas con validez legal',
        verifySignatures: 'Verifica y guarda las firmas del personal',
        verifySignaturesAlt: 'Smartphone visualizando en la app la verificación de la firma',
        requestSignatures: 'Solicita firmas en formularios específicos',
        requestSignaturesAlt:
          'Smartphone visualizando en la app una respuesta y el botón de solicitar firma',
        acceptSignatures: 'Acepta o rechaza firmas',
        acceptSignaturesAlt:
          'Smartphone visualizando en la app una respuesta con firma solicitada y los botones de aceptar y rechazar firma',
        trackSignatures: 'Monitorea el estado de cada firma',
        trackSignaturesAlt:
          'Smartphone visualizando en la app la lista de solicitudes de firma incompletas y sus detalles',
        pdfSignatures: 'Obtén reportes en PDF con firmas digitales',
        pdfSignaturesAlt:
          'Smartphone visualizando en la app el reporte en PDF con las firmas digitales incluidas y remarcadas',
      },
      requestMoreInfo: {
        title: '¡Súmala a tu plan hoy mismo!',
        description:
          'Conversa con un especialista y descubre cómo implementar el módulo en tu organización',
        button: 'Solicitar más información',
        link: 'https://datascope.io/es/nueva_firma/#',
      },
      newFeatures: {
        title: '¡A partir de hoy puedes usar estas nuevas funcionalidades!',
        preConfigTitle: 'Preconfiguración de firmantes',
        preConfigDescription:
          'Define previamente quién debe firmar tus documentos, automatizando flujos recurrentes y ahorrando tiempo.',
        externalSignatureTitle: 'Firma a usuarios externos',
        externalSignatureDescription:
          'Invita a colaboradores fuera de la organización a firmar de manera segura, sin necesidad de que tengan una cuenta en DataScope.',
        sequentialSignatureTitle: 'Configura secuencia de firmas',
        sequentialSignatureDescription:
          'Asigna un orden preestablecido en la firma de documentos para cuando tengas múltiples firmantes involucrados con diferente jerarquía.',
      },
    },
    activation: {
      processTitle: '¡Tu solicitud de activación del módulo de Firmas ya está en proceso!',
      processMessage:
        'Un representante de nuestro equipo se pondrá en contacto contigo para explicarte los detalles del proceso de activación de Firmas.',
      stepsTitle: 'Siguientes pasos',
      step1Title: 'Solicitud de activación del módulo de Firmas ingresada con éxito.',
      step2Title: 'Un experto de DataScope te contactará.',
      step2Description: 'Máximo 1 día hábil',
      step3Title: 'Reunión para presentar el módulo de Firmas.',
      step3Description: 'Fecha a coordinar con especialista',
      step4Title: 'Activación del módulo de Firmas.',
      step4Description: '¡Podrás acceder desde esta misma pestaña!',
    },
  },
  resume: {
    stats: {
      assignedTasks: 'Tareas Asignadas',
      completedTasks: 'Tareas completadas',
      forms: 'Formularios',
      totalForms: 'Total respondidos',
      locations: 'Lugares Visitados',
      totalLocations: 'Total lugares',
      signatures: 'Firmas',
      completedSignatures: 'Firmas completadas',
      findings: '{{finding_label_cap}}s',
      closedFindings: '{{finding_label_cap}}s cerrados',
      previousDays: 'días anteriores',
    },
    emptyState: {
      description:
        '¡Aún no has respondido ningún formulario! Empieza a optimizar tus procesos creando el primero',
      createFirstForm: 'Crear un formulario ahora',
    },
    statuses: {
      pending: 'Pendiente',
      accepted: 'Aceptado',
      rejected: 'Rechazado',
      noStatus: 'Sin estado',
    },
    table: {
      configure: 'Configurar',
      viewAnswer: 'Ver Respuesta',
      form: 'Formulario',
      code: 'Código',
      user: 'Usuario',
      date: 'Fecha',
      status: 'Estado',
      actions: 'Acciones',
      changeLog: 'Registro de cambios',
      modifyAnswer: 'Modificar respuesta',
      chat: 'Chat',
      sendToGoogleSheets: 'Enviar a Google Sheets',
      sendBackupToEmail: 'Enviar respaldo al correo',
      downloadPdf: 'Descargar PDF',
      duplicateAnswer: 'Duplicar respuesta',
      statusUpdateError: 'Hubo un error al actualizar el estado de la respuesta',
      noResults: 'No hay respuestas de formularios que coincidan con los filtros aplicados',
      deleteAnswer: 'Eliminar',
      recoverAnswer: 'Recuperar',
    },
    bulkActions: {
      delete: 'Eliminar',
      changeStatus: 'Cambiar estado',
      selected: 'seleccionados',
      confirmDelete: '¿Estás seguro que quieres eliminar {count} respuestas de formularios?',
      confirmDeleteDescription: 'Una vez eliminados, no podrán ser recuperados',
      cancel: 'Cancelar',
      selectStatus: 'Seleccionar estado',
      select: 'Seleccionar',
      statuses: 'Estados',
      selectStatusPlaceholder: 'Seleccionar un estado',
      statusesUpdated: '¡Estados actualizados exitosamente!',
      errorUpdatingStatuses: 'Error al actualizar estados',
      deleteSuccess: '¡Respuestas eliminadas exitosamente!',
      deleteError: 'Error al eliminar respuestas',
      recover: 'Recuperar',
      recoverSuccess: 'Respuestas recuperadas con éxito',
      recoverError: 'Error al recuperar respuestas',
    },
    filters: {
      addFilter: 'Agregar filtro',
      clearFilters: 'Borrar filtros',
      dateRange: {
        title: 'Fecha',
        popoverTitle: 'Filtrar por fecha',
      },
      location: {
        title: 'Lugar',
        popoverTitle: 'Filtrar por lugar',
        noLocations: 'No se encontraron lugares',
      },
      form: {
        title: 'Formulario',
        popoverTitle: 'Filtrar por formulario',
        inactive: 'Inactivo',
        delete: 'Eliminado',
        folders: 'Carpetas',
        forms: 'Formularios',
      },
      status: {
        title: 'Estado',
        popoverTitle: 'Filtrar por estado',
      },
      user: {
        title: 'Usuario',
        popoverTitle: 'Filtrar por usuario',
        allTab: 'Usuarios',
        groupTab: 'Grupos',
      },
      formCode: {
        title: 'Código del formulario',
        popoverTitle: 'Filtrar por código del formulario',
        placeholder: 'Escribe el código',
      },
      questionAndAnswer: {
        title: 'Pregunta y respuesta',
        popoverTitle: 'Filtrar por pregunta y respuesta',
        questionLabel: 'Pregunta',
        questionPlaceholder: 'Selecciona una pregunta',
        questionTextInputPlaceholder: 'Escribe el nombre de la pregunta',
        answerLabel: 'Respuesta',
        answerDisabledPlaceholder: 'Selecciona una pregunta para activar el filtro',
        answerTextInputPlaceholder: 'Escribe el nombre de una pregunta para activar el filtro',
        answerPlaceholder: 'Escribe la respuesta',
        info: 'El filtro solo se aplicará si hay una pregunta y una respuesta',
        disabledTooltip: 'Para usar este filtro, primero debes agregar un filtro de formulario',
      },
      finding: {
        title: '{{finding_label_cap}}',
        popoverTitle: 'Filtrar por {{finding_label}}',
        includesFinding: 'Incluye {{finding_label}}',
        withoutFindings: 'Sin {{finding_label}}s',
      },
      signature: {
        title: 'Firma',
        popoverTitle: 'Filtrar por firma',
      },
      answeredFrom: {
        title: 'Medio de envío',
        popoverTitle: 'Filtrar por medio de envío',
        mobile: 'Móvil',
        web: 'Web',
      },
      assets: {
        title: 'Activos',
        popoverTitle: 'Filtrar por activos',
        noAssets: 'No se encontraron activos',
      },
    },
    signature: {
      mandatoryIncomplete: 'Firma obligatoria - Incompleta',
      mandatoryComplete: 'Firma obligatoria - Completa',
      optionalIncomplete: 'Firma opcional - Incompleta',
      optionalComplete: 'Firma opcional - Completa',
    },
    recentTitle: 'Formularios Recientes',
    deletedTitle: 'Formularios Eliminados',
    searchBarPlaceholder: 'Buscar por nombre del formulario',
    dateRange: 'Mostrando resultados para',
    changeLog: {
      title: 'Registro de cambios',
      details: 'Ver detalles',
      userChangedAnswer: '{user} cambió la respuesta',
      userChangedState: '{user} cambió el estado de la respuesta a {state}',
      userRecoveredAnswer: '{user} recuperó la respuesta',
      userDeletedAnswer: '{user} eliminó la respuesta',
      userDuplicatedAnswer: '{user} duplicó la respuesta',
      userStartedAnswer: '{user} empezó a responder',
      userResetState: '{user} ha reestablecido el estado de la respuesta',
    },
    close: 'Cerrar',
    export: {
      title: 'Exportar',
      taskForm: 'Formulario',
      dateRange: 'Rango de fecha',
      downloadFormat: 'Formato de descarga',
      email: 'Email',
      downloadFormats: {
        answers: 'Excel agrupado por pregunta',
        forms: 'Excel agrupado por formularios',
        subforms: 'Excel agrupado por preguntas repetibles',
        pdfs: 'Documentos PDF',
      },
      exportInfo: 'Las respuestas serán exportadas conforme a los filtros de la tabla',
      exportFormFilterRequired:
        'Para exportar las respuestas, primero debes filtrar por formulario',
      exportDateRangeLimit:
        'Límite de exportación: 180 días (6 meses). Selecciona un rango de fecha más pequeño',
      cancel: 'Cancelar',
      success: 'Exportación enviada con éxito',
      error: 'Hubo un error al exportar las respuestas',
      disabledForFreeUser: 'Actualiza tu plan para habilitar la exportación de datos',
    },
    sendToGoogleSheets: {
      success: 'Enviado a Google Sheets correctamente',
      error: 'Hubo un error al enviar la respuesta a Google Sheets',
    },
    duplicateAnswer: {
      success: 'Respuesta duplicada exitosamente',
      error: 'Error al duplicar respuesta',
    },
    sendBackupModal: {
      title: 'Enviar respaldo al correo',
      description:
        'Escribe el correo donde quieres recibir el archivo de respaldo de este formulario',
      send: 'Enviar',
      cancel: 'Cancelar',
    },
    deleteAnswer: {
      title: '¿Estás seguro que quieres eliminar esta respuesta?',
      description:
        'Una vez la elimines, podrás recuperarla filtrando por formularios eliminados y restaurándola desde su configuración.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
      success: 'Respuesta eliminada con éxito',
      error: 'Error al eliminar respuesta',
    },
    recoverAnswer: {
      success: 'Respuesta recuperada con éxito',
      error: 'Error al recuperar respuesta',
    },
    statusSelector: {
      newStatus: 'Selecciona o crea un estado',
      newStatusPlaceholder: 'Escribe aquí el nuevo estado',
      newStatusError: 'El estado ya existe',
      delete: 'Eliminar',
      color: 'Color',
      colors: {
        white: 'Blanco',
        blue: 'Azul',
        yellow: 'Amarillo',
        red: 'Rojo',
        green: 'Verde',
        gray: 'Gris',
      },
      editStatusError: 'Error al actualizar estado',
      deleteStatusError: 'Error al eliminar estado',
      createStatusError: 'Error al crear estado',
      deleteConfirmationTitle: '¿Estás seguro que quieres eliminar este estado?',
      deleteConfirmationMessage:
        'Al eliminarlo no podrás recuperarlo, pero las respuestas que lo usen no se verán afectadas',
    },
    chat: {
      notifyUsersError: 'Error al notificar a los usuarios',
    },
    filtersLinkCopy: {
      tooltip: 'Copiar enlace con filtros',
      success: 'Enlace copiado al portapapeles',
    },
    answerView: {
      previous: 'Anterior',
      next: 'Siguiente',
    },
  },
  assets: {
    title: 'Activos',
    assetsSearchPlaceholder: 'Buscar por nombre o identificador',
    historySearchPlaceholder: 'Buscar por nombre, identificador o usuario',
    noAssets: 'No se encontraron activos.',
    noAssetMeters: 'No hay medidores configurados para este activo',
    noHistory: 'No se encontró historial.',
    create: 'Crear',
    update: 'Actualizar',
    createAsset: 'Crear activo',
    name: 'Nombre',
    configuration: 'Configuración',
    addUsers: 'Agregar usuarios',
    showAll: 'Mostrar todos ({count})',
    showLess: 'Mostrar menos',
    usersAssignedSuccess: 'Usuarios asignados exitosamente',
    usersAssignedError: 'Error al asignar usuarios',
    history: 'Historial',
    code: 'Identificador',
    dateAndTime: 'Fecha y hora',
    asset: 'Activo',
    modifiedField: 'Campo modificado',
    modification: 'Modificación',
    modifiedBy: 'Modificado por',
    createNewAsset: 'Crear nuevo activo',
    editAsset: 'Editar activo',
    assetInformation: 'Información del activo',
    meters: 'Medidores',
    metersDescription:
      'Asocia y gestiona los medidores de cada activo para registrar mediciones de forma precisa',
    namePlaceholder: 'Nombre del activo',
    codePlaceholder: 'Número de serie, placa o ID único',
    location: 'Lugar',
    locationPlaceholder: 'Selecciona un lugar',
    usersAndGroups: 'Usuarios y grupos',
    description: 'Descripción',
    descriptionPlaceholder: 'Escribe una descripción para el activo',
    meterType: 'Tipo de medidor',
    meterTypePlaceholder: 'Selecciona un tipo de medidor',
    meter: 'Medidor',
    lastMeasurement: 'Última Medición',
    actions: 'Acciones',
    viewDetails: 'Ver detalle',
    edit: 'Editar',
    delete: 'Eliminar',
    edited: 'Editado',
    editedBy: 'Editado por',
    previousValue: 'Valor anterior',
    confirmDeleteTitle: '¿Estás seguro que quieres eliminar este activo?',
    confirmDeleteDescription:
      'El activo {assetName} se eliminará, pero los datos registrados anteriormente se conservarán.',
    cancel: 'Cancelar',
    assetCreated: 'Activo creado exitosamente',
    assetUpdated: 'Activo actualizado exitosamente',
    assetDeleted: 'Activo eliminado exitosamente',
    assetDeletedError: 'Error al eliminar activo',
    assetUpdatedError: 'Error al actualizar activo',
    assetCreatedError: 'Error al crear activo',
    assetLimitReachedError:
      'Límite de activos alcanzado. No puedes crear más activos con tu plan actual.',
    assetCodeAlreadyExists: 'El código del activo ya existe',
    assetInfo: 'Información del activo',
    export: 'Exportar',
    import: 'Importar',
    editTableColumns: 'Personalizar columnas',
    columnLimitTooltip: 'Has alcanzado el límite de 6 columnas visibles',
    selectedCount: '{count} seleccionado(s)',
    changeTypeButton: 'Cambiar tipo de activo',
    changeTypeTitle: 'Cambiar tipo de activo',
    changeTypeInfo: 'Reemplazará el tipo actual de los activos seleccionados',
    changeTypeApply: 'Agregar',
    changeTypeSearchPlaceholder: 'Buscar un tipo de activo',
    confirmChangeTypeTitle: '¿Estás seguro de cambiar el tipo de los activos seleccionados?',
    confirmChangeTypeMessage:
      'Los campos personalizados en los activos seleccionados no estarán visibles, pero la información seguirá registrada.',
    usersAndGroupsTooltip:
      'Debes asignar al menos un usuario para que pueda ver y gestionar este activo. Si no seleccionas ninguno, nadie tendrá acceso.',
    v1MetersDescription: 'Actualmente, solo soportamos medidores de tipo horómetro.',
    addUsersDescription:
      'Los usuarios seleccionados tendrán acceso a este activo para consultar información y realizar acciones según sus permisos.',
    findOutMore: 'Saber más',
    findOutMoreLink: 'https://help.mydatascope.com/es/articles/12098023-activos-en-datascope',
    betaBannerTitle: 'Activos está en beta',
    betaBannerDescription:
      'Estamos trabajando en la versión completa, que incluirá propiedades, medidores y lugares. Muy pronto disponible en planes pagos.',
    moreInfo: 'Más información',
    viewMeasurements: 'Ver mediciones',
    noMeasurements: 'Sin mediciones',
    noData: 'Sin datos',
    blockedAssetTooltip:
      'Este activo está bloqueado por límite de plan. Actualiza tu plan para acceder al detalle.',
    blockedAssetHistoryTooltip:
      'Este activo está limitado por tu plan actual. Actualiza tu plan para ver los detalles del historial.',
    changeTypes: {
      asset_created: 'Activo creado',
      asset_deleted: 'Activo eliminado',
      added_user: 'Usuario(s) asignado(s)',
      removed_user: 'Usuario(s) eliminado(s)',
      added_group: 'Grupo(s) asignado(s)',
      removed_group: 'Grupo(s) eliminado(s)',
      added_meter: 'Medidor(es) asignado(s)',
      removed_meter: 'Medidor(es) eliminado(s)',
      name: 'Nombre cambiado',
      code: 'Código cambiado',
      description: 'Descripción cambiada',
      location_name: 'Ubicación cambiada',
      asset_type: 'Tipo de activo cambiado',
    },
    measurementUnits: {
      hour: 'horas',
      minute: 'min',
      seconds: 'seg',
      day: 'día',
      month: 'mes',
      year: 'año',
      week: 'semana',
      millisecond: 'ms',
      mile: 'mi',
      kilometer: 'km',
      meter: 'm',
      foot: 'ft',
      yard: 'yd',
      inch: 'in',
      centimeter: 'cm',
      millimeter: 'mm',
      celsius: '°C',
      fahrenheit: '°F',
      kelvin: 'K',
      volt: 'V',
      megavolt: 'MV',
      kilovolt: 'kV',
      millivolt: 'mV',
      microvolt: 'µV',
    },
    importDrawer: {
      title: 'Importar Activos',
      step1Title: 'Paso 1: Descarga el archivo',
      step1Description:
        'Descarga el archivo de ejemplo. Contendrá una hoja por cada tipo de activo configurado en tu cuenta. Asegúrate de campos marcados con * para importar tu archivo correctamente.',
      step1DescriptionPart1:
        'Descarga el archivo de ejemplo. Contendrá una hoja por cada tipo de activo configurado en tu cuenta. Asegúrate de campos marcados con',
      step1DescriptionPart2: 'para importar tu archivo correctamente.',
      downloadExample: 'Descargar ejemplo',
      step2Title: 'Paso 2: Edita el archivo',
      step3Title: 'Paso 3: Sube tu archivo',
      step3Description: 'Arrastra y suelta tu archivo aquí o selecciónalo desde tu computadora.',
      dragDropText: 'Arrastra y suelta aquí tu Excel',
      browseText: 'o búscalo en tu computador',
      replaceText: 'Reemplazar',
      fileUploadedText: 'Tu archivo ha sido cargado',
      invalidFileType: 'Por favor selecciona un archivo Excel válido (.xlsx)',
      importSuccess: 'Activos importados correctamente',
      importError: 'Error al importar activos',
      importButton: 'Importar',
      cancel: 'Cancelar',
      importing: 'Importando...',
      importingDescription: 'Un momento, estamos organizando todo...',
      errorTitle: 'Detectamos un error.',
      errorMessage: 'Por favor, verifica que tus datos tengan el formato correcto.',
      sheetsWithErrorsMessage: 'El archivo contiene errores en las hojas: ',
      sheetsWithErrorsRecommendation:
        'Revisa las hojas indicadas y corrige los datos para continuar.',
      andMore: 'y {remainingCount} más',
      nameErrorMessage: '{errorCount} filas fueron enviadas sin nombre de activo.',
      noCodeWarning:
        '{noCodeCount} filas fueron enviadas sin un identificador de activo. Se generó un identificador automáticamente para ellos.',
      templateDownloadError: 'Error al descargar el archivo de ejemplo',
      downloadingTemplate: 'Descargando...',
      errorsDetected: 'Detectamos errores en {count} fila(s):',
      showMore: 'Mostrar más',
      showLess: 'Mostrar menos',
    },
    exportSuccess: 'Activos exportados correctamente',
    exportError: 'Error al exportar activos',
    exporting: 'Exportando...',
    origin: 'Origen',
    value: 'Valor',
    assetsCreated: 'activos creados',
    duplicatesSkipped: 'duplicados omitidos',
    errorsCount: 'errores',
    readings: 'Mediciones',
    configure: 'Configurar',
    measurementUpdated: 'Editado exitosamente',
    measurementUpdatedError: 'Error al editar',
    measurementDeleted: 'Eliminado exitosamente',
    measurementDeletedError: 'Error al eliminar',
    confirmDeleteMeasurementTitle: '¿Estás seguro de que quieres eliminar esta medición?',
    confirmDeleteMeasurementDescription:
      'Esta acción es permanente y la medición ya no aparecerá en la tabla.',
    mustEnterNumber: 'Debes ingresar un número',
    action: 'Acción realizada',
    newValue: 'Nuevo valor',
    measurements: 'Mediciones',
    historyTitle: 'Historial de cambios',
    deleted: 'Eliminado',
    measurementsHistoryEmptyState: 'Aún no hay modificaciones en este medidor',
    formCustomFieldsLabel: 'Detalles del activo',
    imageDragDropText: 'Arrastra y suelta una imagen aquí',
    filesDragDropText: 'Arrastra y suelta archivos aquí',
    uploadFileError: 'Error al subir el archivo',
    assetLimitReachedTitle: 'Límite de activos alcanzado',
    assetLimitReachedDescription:
      'Has alcanzado el límite de activos en tu plan. Para agregar o gestionar más activos, actualiza tu plan y obtén acceso a más funciones:',
    assetLimitFeature1: 'Mayor cantidad de activos disponibles',
    assetLimitFeature2: 'Historial completo de activos',
    assetLimitFeature3: 'Información completa de los activos',
    assetLimitUpgradeButton: 'Desbloquear más activos ahora',
    assetLimitContinueButton: 'Seguir con mi plan actual',
    limitedFeaturesAlert:
      'Algunas funciones no están disponibles en tu plan actual. Actualiza tu plan para ver todas las lecturas y configuraciones de tus activos.',
    changePlan: 'Cambiar plan',
    assetTypes: {
      title: 'Tipos de activos',
      noAssetTypes: 'No se encontraron tipos de activos',
      create: 'Crear',
      createAssetType: 'Crear tipo de activo',
      createAssetTypeSuccess: 'Tipo de activo creado correctamente',
      createAssetTypeError: 'Error al crear el tipo de activo',
      createAssetTypeErrorDuplicateName: 'El nombre del tipo de activo ya existe',
      type: 'Tipo de activo',
      description: 'Descripción',
      createdAssets: 'Activos creados',
      actions: 'Acciones',
      confirmDeleteTitle: '¿Estás seguro de eliminar este tipo de activo?',
      confirmDeleteDescription:
        'El tipo de activo {assetTypeName} se eliminará. Esta acción no se puede deshacer.',
      assetTypeDeleted: 'Tipo de activo eliminado correctamente',
      assetTypeDeletedError: 'Error al eliminar el tipo de activo',
      searchPlaceholder: 'Buscar tipo de activo',
      viewAssets: 'Ver activos',
      assetTypeDeleteSuccess: 'Tipo de activo eliminado correctamente',
      assetTypeDeleteError: 'Error al eliminar el tipo de activo',
      assetTypeUpdateSuccess: 'Tipo de activo actualizado correctamente',
      assetTypeUpdateError: 'Error al actualizar el tipo de activo',
      formTitleEdit: 'Editar tipo de activo',
      formSubtitleCreate: 'Proporciona los datos para cada atributo del tipo de activo.',
      formSubtitleEdit: 'Actualiza los atributos del tipo de activo y guarda los cambios.',
      formNameLabel: 'Nombre',
      formDescriptionLabel: 'Descripción',
      formCustomIdLabel: 'Nombre de ID personalizado',
      formIconLabel: 'Ícono',
      formLoadError: 'No fue posible cargar este tipo de activo.',
      formBackToList: 'Volver a tipos de activos',
      formReset: 'Restablecer',
      formSave: 'Guardar',
      formCancel: 'Cancelar',
      formMeterSelectLabel: 'Selecciona un medidor',
      formCustomIdTooltip:
        'Para una mejor experiencia, tus activos deben tener un identificador único. Llámalo como quieras: ID, Placa, Serial, etc',
      iconSelectorColors: 'Colores',
      iconSelectorIcons: 'Íconos',
      addMeterTitle: 'Agregar medidor',
      addMeterDescription:
        'Agrega medidores según el uso de tu activo. Podrás editarlos cuando lo necesites',
      addMeterPlaceholder: 'Selecciona un medidor para tu tipo de activo',
      addFieldsTitle: 'Añadir campos personalizados',
      addFieldsDescription:
        'Define los campos que aparecerán en el formulario de creación de activos',
      addFieldButton: 'Agregar campo',
      requiredField: 'Campo obligatorio',
      backToAssets: 'Volver a activos',
      fieldNameAlreadyExists: 'El nombre del campo personalizado ya existe',
      reachedAssetTypeFieldsLimit: 'Has alcanzado el límite de campos para un tipo de activo',
      selectType: 'Selecciona un tipo de activo',
      search: 'Buscar tipos de activos...',
      fieldTypes: {
        text: 'Texto',
        number: 'Número',
        date: 'Fecha',
        image: 'Imagen',
        files: 'Archivos',
      },
      fileTypeSelector: {
        label: 'Tipo de archivo',
        allFormats: 'Todos los formatos',
        audio: 'Audio',
        video: 'Video',
      },
    },
  },
  mainMenu: {
    home: 'Inicio',
    forms: 'Formularios',
    integrations: 'Integraciones',
    taskAssigner: 'Asignar tareas',
    findings: '{{finding_label_cap}}s',
    signatures: 'Firmas',
    locations: 'Lugares',
    lists: 'Listas',
    assets: 'Activos',
    charts: 'Gráficas',
    map: 'Mapa',
    sensors: 'Sensores',
    training: 'Capacitaciones',
    settings: {
      main: 'Ajustes y ayuda',
      changelog: 'Notificaciones',
      account: 'Ajustes cuenta',
      users: 'Usuarios',
      billing: 'Pagos',
      invite: 'Invita y gana',
      helpCenter: 'Centro de ayuda',
      news: 'Novedades',
      upgrade: 'Mejorar plan',
    },
    new: 'Nuevo',
  },
  mainTopBar: {
    createIssue: 'Crear {{finding_label}}',
    featureRequest: 'Envíanos tu idea',
    featureRequestText: '¿Necesitas una herramienta que aún no tenemos?',
    logout: 'Cerrar sesión',
    languageOptions: {
      es: 'Español',
      en: 'Inglés',
      pt: 'Portugués',
    },
    newNotifications: 'Nuevo mensaje en {formName}',
    companySettings: 'Ajustes de empresa',
    myAccount: 'Mi cuenta',
  },
  notFound: {
    title: '404',
    description:
      'Lo sentimos, pero la página que estás buscando no se encuentra. Intenta verificar la URL para un error, luego haz clic en el botón de actualización en tu navegador o intenta encontrar algo más en nuestra aplicación.',
    button: 'Ir a inicio',
  },
  actionsOverview: {
    title: 'Acciones mensuales disponibles',
    explanation: '¿Qué son las acciones?',
    actionsUsed: 'Acciones usadas',
    exceedActionsInfo:
      'Si realizas más acciones de las incluidas en tu plan, se aplicará un cargo adicional por cada una.',
    moreInfo: 'Más información',
    error: 'Error al cargar información de acciones',
    explanationLink:
      'https://help.mydatascope.com/es/articles/11321884-planes-de-datascope-como-funcionan-y-que-incluyen#h_23898674ca',
    moreInfoLink:
      'https://help.mydatascope.com/es/articles/11321884-planes-de-datascope-como-funcionan-y-que-incluyen#h_5897cfe9c1',
  },
  billing: {
    externalIframe: {
      tokenAuthorizeError: 'No pudimos autorizar tu sesión. Por favor, refresca la página.',
    },
  },
  maps: {
    title: 'Ubica tus respuestas en el mapa',
    emptyState: {
      title: 'Mapea tus respuestas fácilmente',
      subtitle: '¿Para qué usar la función de mapas?',
      description: 'Con esta funcionalidad es posible:',
      feature1:
        'Visualizar en tiempo real dónde se completan formularios, se ejecutan tareas o se reportan {{finding_label}}s.',
      feature2:
        'Detectar zonas con baja o alta cobertura para tomar decisiones operativas estratégicas.',
      feature3: 'Obtener trazabilidad y control geográfico de las operaciones diarias.',
      demo: {
        title: 'Visualiza la ubicación de tus respuestas',
        mobile: {
          title: 'Responde desde terreno con la app',
          description:
            'Responde desde la app con ubicación GPS activada y valida que las respuestas fueron enviadas desde el lugar asignado.',
          description2:
            '¡Importante! Asegúrate que tu equipo registre respuestas usando la app con la ubicación habilitada.',
        },
        web: {
          title: 'Visualiza tus respuestas en el mapa',
          description:
            'Una vez respondas tus formularios desde la App podrás visualizar tus respuestas en un mapa interactivo.',
        },
      },
    },
  },
  lists: {
    banner: {
      message:
        '¡Lugares nuevos ya están disponibles! Ahora puedes organizar, asignar usuarios y visualizar la actividad en un solo lugar.',
      action: 'Prueba ahora',
    },
  },
  mfa: {
    title: 'Activa el 2FA',
    next: 'Siguiente',
    finish: 'Finalizar',
    close: 'Cerrar',
    scanQr: 'Escanea el código QR',
    scanQrDescription:
      'Escanea el QR con Google Authenticator, Authy o la app de autentificación de tu preferencia',
    manualEntry: 'O ingresa el código manualmente',
    verifying: 'Verificando...',
    verifyCode: 'Ingresa el código de autenticación',
    verifyCodeDescription: 'Escribe el código de 6 dígitos que aparece en tu app de autenticación',
    verifyCodeInvalid: 'Código incorrecto. Inténtalo de nuevo.',
    verifyCodeError: 'Error al verificar el código',
    verifyCodeCognitoError: 'Tuvimos un error interno. Escríbenos por el chat para solucionarlo.',
    successTitle: 'Autenticación configurada con éxito',
    successDescription:
      'A partir de ahora, cada vez que inicies sesión, se te pedirá un código temporal desde tu app autenticadora para mayor seguridad',
    successDescriptionMobile:
      'Para continuar, por favor cierra la app de DataScope y ábrela nuevamente.',
    maybeLater: 'Más tarde',
    activateNow: 'Activar ahora',
    protectAccount: 'Protege tu cuenta con una capa extra de seguridad',
    protectAccountDescription:
      'Con la autenticación en dos pasos, necesitarás un código temporal desde una app como Google Authenticator o Authy para iniciar sesión. Podrás gestionar esta configuración más adelante desde tu perfil de usuario.',
    organizationRequires: 'Tu organización requiere activar la autenticación en dos pasos (2FA)',
    organizationRequiresDescription:
      'Usa una app como Google Authenticator o Authy para generar el código temporal que se pedirá al iniciar sesión',
    userSettings: {
      title: 'Seguridad de la cuenta (2FA)',
      descriptionActive:
        'Añade una capa extra de seguridad a tu cuenta.\n Al activar la autenticación en dos pasos (2FA), se solicitará un código desde una app como Google Authenticator o Authy al iniciar sesión.',
      descriptionDisable:
        'Tienes activada la verificación en dos pasos. Para iniciar sesión necesitas un código temporal de tu app autenticadora.\nPuedes quitarla, pero tu cuenta será menos segura.',
      activate: 'Activar 2FA',
      disableConfig: 'Quitar verificación en dos pasos',
      disableDialogTitle: '¿Quieres quitar la verificación en dos pasos?',
      disableDialogDescription:
        'Si la quitas, tu cuenta quedará menos protegida. Podrás activarla otra vez cuando quieras.',
      disableDialogConfirm: 'Quitar',
      disableDialogCancel: 'Cancelar',
      justSameUserCanActivate:
        'Solo el mismo usuario puede activar la autenticación en dos pasos(2FA)',
    },
  },
};
